import EN from './EN';

export default {
  quickActions: 'အမြန်လုပ်ဆောင်ချက်များ',
  ...EN,
  servers: {
    name: 'ဆာဗာ',
    auto: 'အလိုအလျောက်',
    vietnam: 'ဗီယက်နမ်',
    singapore: 'စင်ကာပူ',
    main: 'ပင်မ',
    reserve: 'အရန်'
  },
  takeAway: 'အိမ်ပို့ယူပါ',
  printBill: 'ဘီလ်ထုတ်ပါ',
  barcodeText: 'ကုတ်နံပါတ် (စာလုံးများ)',
  now: 'ယခု',
  hour: 'နာရီ',
  minutes: 'မိနစ်',
  second: 'စက္ကန့်',
  limitFeatureForFree: 'ဒီလုပ်ဆောင်ချက်ကို Premium ဗားရှင်းတွင်သာ အသုံးပြုနိုင်ပါသည်။ အသုံးပြုရန် အဆင့်မြှင့်တင်ပါ!',
  orderIsPaying: 'အော်ဒါအားပေးချေနေသည်',
  canUpdateOrder: 'သင်ဖျက်လိုသောအရာအား အတည်ပြုပါ။ ပြင်ဆင်မှုများကို အပ်ဒိတ်မလုပ်ပါ!',
  charge: 'ငွေသွင်းပါ',
  checkout: 'ငွေသွင်းပါ',
  commingSoon: 'မကြာမီရနိုင်မည်',
  upcoming: 'လာမည့်အချိန်',
  showing: 'ပြနေသည်',
  addShortCut: 'ဖြတ်လမ်းထည့်ပါ',
  billUIChoice: 'ဘီလ်အင်တာဖေ့စ်ရွေးချယ်ပါ',
  qrUIChoice: 'QR ကုတ်အင်တာဖေ့စ်ရွေးချယ်ပါ',
  devicePermissionDenied: 'ဒီလုပ်ဆောင်ချက်အတွက် ခွင့်ပြုချက်လိုအပ်ပါသည်!',
  permissionNotifyInfo: 'ဒီလုပ်ဆောင်ချက်အတွက် ခွင့်ပြုချက်ပေးရမည်!',
  oldVersion: 'ဟောင်းသောဗားရှင်း',
  changeText: 'ပြောင်းပါ',
  confirmDelete: 'ဒီအရာအား ဖျက်လိုသလား?',
  value: 'တန်ဖိုး',
  deprecated: 'မကြာမီမသုံးတော့',
  saving: 'စုဆောင်းခြင်း',
  active: 'အသက်ဝင်နေသည်',
  notActive: 'မသက်ဝင်ရသေးပါ',
  hidden: 'ဝှက်ထားသည်',
  content: 'အကြောင်းအရာ',
  featureUnderDev: 'ဒီလုပ်ဆောင်ချက်ကို ကျွန်ုပ်တို့အဖွဲ့တွင်အဆင့်မြှင့်နေဆဲဖြစ်ပါသည်။ နောက်တစ်ကြိမ် ပြန်လာရအောင်!',
  spending: 'အသုံးစရိတ်',
  overview: 'အကျဉ်းချုပ်',
  recommend: 'အကြံပြုသည်',
  savePdf: 'PDF ဖိုင်သိမ်းပါ',
  bankQR: 'ဘဏ် QR ကုဒ်',
  quantityInvalid: 'အရေအတွက် မမှန်ပါ',
  returnToHome: 'မူလမျက်နှာသို့ ပြန်သွားပါ',
  forever: 'အမြဲတမ်း',
  expired: 'သက်တမ်းကုန်သည်',
  expiredShort: 'သက်တမ်းကုန်',
  barcodeTable: 'ထုတ်ကုန်ဘားကုဒ်ဇယား',
  price: 'စျေးနှုန်း',
  autoGen: 'အလိုအလျောက်ဖန်တီးပါ',
  check: 'စစ်ဆေးပါ',
  signature: 'လက်မှတ်',
  permission: 'ခွင့်ပြုချက်',
  staffLogin: 'ဝန်ထမ်းလော့ဂ်အင်',
  staffSale: 'အရောင်းဝန်ထမ်း',
  updateInfo: 'အချက်အလက်ပြင်ဆင်ပါ',
  staffPermission: {
    title: 'ဝန်ထမ်းခွင့်ပြုချက်',
    detail: 'ဝန်ထမ်းများကို WEB/APP အမျိုးမျိုးတွင် အသုံးပြုခွင့်ပြုပါ။ ဝန်ထမ်းများအတွက်အထူးအသုံးပြုရန် App တစ်ခု အချို့ကိုမပါဝင်နိုင်ပါ',
    allOrderType: 'ရောင်းရန်အော်ဒါ, ဝယ်ရန်အော်ဒါ, အော်ဒါပြန်အမ်း',
    showRevenue: 'အော်ဒါအတွက် အမြတ်နှင့်နောက်ခံပြပါ',
    editPriceDetail: 'အရောင်းတန်ဖိုးကို ပြောင်းလဲခွင့်ပြုပါ။ သို့မဟုတ် ပုံမှန်လက်လီစျေးနှုန်းဖြင့်ရောင်းပါမည်',
    financial: 'ငွေဝင်ငွေထွက်မှတ်တမ်း',
    showAllCustomerDetail: 'ဒီဝန်ထမ်း မဖန်တီးထားသော ဖောက်သည်များကိုလည်းကြည့်နိုင်သည်',
    showAllCustomer: 'ဖောက်သည်အားလုံး ပြပါ',
    editPrice: 'အရောင်းဈေးပြောင်းခွင့်ပြုသည်',
    dataOperation: 'ဒေတာ စီမံခန့်ခွဲခွင့်များ',
    featuresAndStats: 'ကြည့်ရှုခြင်းနှင့် လုပ်ဆောင်ချက် ခွင့်ပြုချက်များ'
  },
  renew: 'ယခုဝယ်ယူပါ',
  updatedAt: 'နောက်ဆုံးဖွင့်ချိန်',
  saveDraft: 'မူကြမ်းသိမ်းဆည်းပါ',
  buy: 'ဝယ်ပါ',
  birthday: 'မွေးနေ့',
  barcodeNotFound: 'ဒီဘားကုဒ်ကိုရှာမတွေ့ပါ!',
  saved: 'သိမ်းဆည်းပြီးပါပြီ',
  reality: 'လက်တွေ့',
  difference: 'ကွာခြားမှု',
  hide: 'ဝှက်ပါ',
  editComponent: 'Interface တည်းဖြတ်ပါ',
  amount: 'အရေအတွက်',
  search: 'ရှာဖွေပါ',
  simple: 'ရိုးရှင်းသည်',
  more: 'ပိုမို',
  share: 'မျှဝေပါ',
  inventoryDelivery: 'လက်ကျန်ပစ္စည်းထုတ်',
  type: 'အမျိုးအစား',
  transactionHistory: 'ငွေလွှဲမှတ်တမ်း',
  limitWarning: 'သင်၏အကောင့်အား ပေးဆောင်မှုပြန်လည်ရုပ်သိမ်းခြင်းကြောင့် ကန့်သတ်ထားသည်။ သုံးကြိမ်ကျော်လျှင် အကောင့်အား အပြီးတိုင်ပိတ်ထားမည်။',
  upgradePro: 'အဆင့်မြှင့်တင်ပါ',
  iapSupport: 'ဘဏ်လွှဲ၍ ၆လထက်ပိုသောแพ็คเกจတွင် ၅% လျှော့စျေးရနိုင်ပါသည်။ Messenger မှဆက်သွယ်ပါ',
  emptyData: 'အချက်အလက်မရှိပါ',
  seemore: 'နောက်ထပ်ကြည့်ပါ',
  version: 'ဗားရှင်း',
  financialIn30days: 'မကြာသေးမီ ၃၀ ရက်တွင် ငွေကြေး',
  financialInMonth: 'ယခုလ ငွေကြေး',
  orFastLoginWith: 'သို့မဟုတ် Google၊ Apple နှင့် လျှင်မြန်ဝင်ပါ',
  fontSize: 'စာလုံးအရွယ်အစား',
  changeFontSizeWarning: 'စာလုံးအရွယ်အစားပြောင်းပြီးပါပြီ။ ထွက်ပြီး ပြန်ဝင်ပါရန် အကြံပြုသည်',
  fontSizeList: ['အလွန်သေး', 'သေး', 'ပုံမှန်', 'ကြီး', 'အလွန်ကြီး', 'အလွန်ကြီးအဆန်းထက်'],
  contact: 'ဆက်သွယ်ရန်',
  cause: 'အကြောင်းရင်း',
  default: 'ပုံသေ',
  manager: 'မန်နေဂျာ',
  paymentMethod: 'ငွေပေးချေမှုနည်းလမ်း',
  paymentMethodList: ['ငွေသား', 'ဘဏ်ငွေလွှဲ', 'အကြွေး'],
  printerVideoDemo: 'ပရင်တာဆက်သွယ်နည်း ဗီဒီယိုလမ်းညွှန်',
  supportWarning: 'အကူအညီလိုအပ်ပါက Facebook မှတဆင့် အဖွဲ့ကိုဆက်သွယ်ပါ။ \nအတူတကွပံ့ပိုးပေးခြင်းအတွက် ကျေးဇူးတင်ပါတယ်!',
  offlineWarning: 'သင်အော့ဖ်လိုင်းအသုံးပြုနေပါတယ်။ အချက်အလက်ဆုံးရှုံးမဖြစ်ရန်နှင့် အခြားသောအင်္ဂါရပ်များကို အသုံးပြုနိုင်ရန် အွန်လိုင်းအကောင့်တစ်ခု စာရင်းသွင်းပါ။',
  updating: 'နောက်ဆုံးရေးသားနေသည်',
  remain: 'ကျန်ရှိ',
  choiceProductTypeWarning: 'အမျိုးအစားရွေးချယ်ပါ',
  choiceProductUnitConvertWarning: 'ပစ္စည်းယူနစ်ရွေးပါ',
  editProduct: 'ပစ္စည်းပြင်ဆင်ပါ',
  onlyOnlineSupport: 'ဤလုပ်ဆောင်ချက်သည် အွန်လိုင်းတွင်သာထောက်ပံ့ပါသည်။ အကောင့်ဖြင့်လော့ဂ်အင်ဝင်ပါ။',
  createBy: 'ဖန်တီးသူ',
  userName: 'အသုံးပြုသူအမည်',
  fullName: 'အမည်အပြည့်အစုံ',
  webVersion: 'ဝဘ်ဗားရှင်း (ကွန်ပျူတာ)',
  syncingProgress: 'ဒေတာချိန်းညှိနေပါသည်။ ကျေးဇူးပြု၍ 1-15 မိနစ်စောင့်ပါ။ ပြီးဆုံးသည့်အခါ အီးမေးလ်ဖြင့်အသိပေးပါမည်။',
  bulkDelete: 'အများအပြားဖျက်ပါ',
  sync: 'ချိန်းညှိပါ',
  offline: 'အော့ဖ်လိုင်း',
  offlineNotSupport: 'အွန်လိုင်းတွင်သာထောက်ပံ့သည်',
  warning: 'သတိပေးချက်',
  back: 'နောက်သို့',
  yes: 'ဟုတ်ကဲ့',
  no: 'မဟုတ်ပါ',
  refresh: 'ပြန်လည်ပြင်ဆင်ပါ',
  tryAgain: 'ထပ်မံကြိုးစားပါ',
  home: 'မူလ',
  language: 'ဘာသာစကား',
  theme: 'အပြင်အဆင်',
  dark: 'အမှောင်',
  light: 'အလင်း',
  total: 'စုစုပေါင်း',
  quantity: 'အရေအတွက်',
  totalMoney: 'စုစုပေါင်းငွေ',
  paid: 'ပေးချေပြီး',
  totalDebit: 'စုစုပေါင်းအကြွေး',
  totalReminder: 'ကျန်ရှိငွေ',
  totalOldDebit: 'ယခင်အကြွေး',
  totalOldReminder: 'ယခင်ကျန်ရှိငွေ',
  blanceAndDebt: 'အကြွေး/ကျန်ငွေ',
  debit: 'အကြွေး',
  remainder: 'ကျန်ရှိ',
  arrears: 'ကျန်အကြွေး',
  status: 'အခြေအနေ',
  create: 'ဖန်တီးပါ',
  add: 'ထည့်ပါ',
  save: 'သိမ်းပါ',
  saveImage: 'ပုံသိမ်းပါ',
  next: 'နောက်တစ်ခု',
  print: 'ပုံနှိပ်ပါ',
  oldPrint: 'ဘီလ်ပုံနှိပ် (ရိုးရိုး)',
  export: 'ထုတ်ပေးပါ',
  edit: 'တည်းဖြတ်ပါ',
  copy: 'ကူးယူပါ',
  copied: 'ကူးယူပြီး!',
  delete: 'ဖျက်ပါ',
  update: 'အသစ်ပြင်ဆင်ပါ',
  updateStatus: 'အခြေအနေပြင်ဆင်ပါ',
  day: 'နေ့',
  month: 'လ',
  year: 'နှစ်',
  from: 'မှ',
  to: 'သို့',
  fromDate: 'မှ စ၍',
  toDate: 'ထိ',
  choiceImage: 'ပုံရွေးချယ်ပါ',
  exist: 'ရှိပြီးသား',
  invalidParams: 'တင်းကျပ်ချက်ရှိသော အချက်အလက်များဖြည့်ပါ',
  success: 'အောင်မြင်သည်',
  fail: 'မအောင်မြင်ပါ',
  all: 'အားလုံး',
  complete: 'ပြီးစီးသည်',
  pending: 'ဆိုင်းငံ့နေသည်',
  canceled: 'ပယ်ဖျက်ပြီး',
  cancel: 'ပယ်ဖျက်ပါ',
  ok: 'အိုကေ',
  or: 'သို့မဟုတ်',
  choice: 'ရွေးချယ်ပါ',
  confirm: 'အတည်ပြုပါ',
  confirmExitApp: 'အက်ပ်ထွက်လိုသလား?',
  time: 'အချိန်',
  notFound: 'အချက်အလက်ရှာမတွေ့ပါ။ ထပ်မံကြိုးစားပါ!',
  createdAt: 'ဖန်တီးချိန်',
  none: 'မရှိပါ',
  detail: 'အသေးစိတ်',
  filter: 'စိစစ်ပါ',
  filterByTim: 'အချိန်ဖြင့်စိစစ်ပါ',
  note: 'မှတ်ချက်',
  trial: 'စမ်းသပ်မှု',
  option: 'ရွေးချယ်စရာ',
  notify: 'အသိပေးချက်',
  understand: 'နားလည်ပါသည်',
  exportToExcel: 'Excel ထုတ်ပေးပါ',
  multiHidden: 'အများအပြား ဖုံးကွယ်',
  multiActive: 'အများအပြား ဖွင့်ပါ',
  hiddenList: 'ဖုံးကွယ်ထားသောစာရင်း',
  showList: 'ဖွင့်ထားသောစာရင်း',
  importDataFromExcel: 'Excel မှဒေတာတင်သွင်းပါ',
  describe: 'ထုတ်ကုန်အကြောင်းပြောပါ',
  addImage: 'ရုပ်ပုံထည့်ပါ',
  limitUpload: 'ထုတ်ကုန်တစ်ခုတွင် ဓာတ်ပုံအများဆုံး ၅ ပုံထည့်နိုင်ပါသည်',
  limitFeature: {
    intro: 'သင့်အားလုံးအခမဲ့အသုံးပြုနိုင်ပါသည်။ အင်္ဂါရပ်များကိုအသုံးပြုလိုပါက ပေးဆောင်ပါ။',
    free: 'အခမဲ့ဗားရှင်း',
    pro: 'အဆင့်မြှင့်ဗားရှင်း (ပေးဆောင်ရမည့်)',
    title: 'ဤလုပ်ဆောင်ချက်ကိုအသုံးပြုရန် အဆင့်မြှင့်ဗားရှင်းဝယ်ယူပါ',
    package: 'အဆင့်မြှင့်စီမံခန့်ခွဲမှုပက်ကေ့ဂျ်များ',
    packageOther: 'အခြားဝန်ဆောင်မှုပက်ကေ့ဂျ်များ',
    features: [
      'ကြော်ငြာမပါဝင်ပါ',
      'ကုန်ပစ္စည်းအရေအတွက်မကန့်သတ်ပါ',
      'အော်ဒါအရေအတွက်မကန့်သတ်ပါ',
      'ထုတ်ကုန်ဘားကုဒ်ပုံနှိပ်နိုင်မှု (ဝဘ်ဗားရှင်းတွင်သာ)',
      'ဖောက်သည်အတွက်အမှတ်တံဆိပ်ရယူမှု',
      'အော်ဒါမိတ္တူယူမှု',
      'ရောင်းသူမှပေးဆောင်ရန်ပေါင်းစီမှု',
      'အော်ဒါပြန်အမ်းမှု',
      'ဟောင်းသောကုန်ပစ္စည်းဝှက်မှု',
      'ကုန်ပစ္စည်းခွဲခြားမှု (ဥပမာ-ဂျင်းဘောင်းဘီမှာ M, L, XL အရွယ်အစားများရှိသည်)',
      'Excel ဖိုင်မှ ဒေတာတင်သွင်း/ထုတ်ယူမှု',
      'ငွေဝင်/ငွေထွက် စာရင်းထည့်သွင်းမှု',
      'ဖောက်သည်များအတွက် အကြွေးစာရင်းထည့်သွင်းမှု',
      'ပစ္စည်းအပိုင်းထုတ်ယူမှု',
      'QR ကုဒ်လွှဲပြောင်းငွေပေးချေမှု',
      'အွန်လိုင်းမရှိဘဲ မူကြမ်းဖန်တီးမှု',
      'ကုန်ပစ္စည်းတစ်ခုတွင် ဓာတ်ပုံအများဆုံး ၅ ပုံ',
      'ဝဘ်ဗားရှင်းကိုမကန့်သတ်အသုံးပြုနိုင်ပါသည်'
    ],
    freeFeatures: [
      'ကြော်ငြာပါဝင်ပါသည်',
      'ကုန်ပစ္စည်း ၁၀၀ အထိသာဖြည့်နိုင်သည်။ (အွန်လိုင်းဗားရှင်း)',
      'အော်ဒါ ၂,၀၀၀ အထိသာဖြည့်နိုင်သည်။ (အွန်လိုင်းဗားရှင်း)',
      'ဟောင်းသောကုန်ပစ္စည်းဝှက်မှု',
      'ရောင်းသူမှပေးဆောင်ရန်ပေါင်းစီမှု',
      'အော်ဒါပြန်အမ်းမှု',
      'ဘားကုဒ်ပုံနှိပ်မှု (ဝဘ်ဗားရှင်း)',
      'ဖောက်သည်အမှတ်တံဆိပ်ရယူမှု',
      'ကုန်ပစ္စည်းခွဲခြားမှု',
      'ဘီလ်နှင့်တင်ပြမှု',
      'Excel မှ ဒေတာတင်သွင်းမှု',
      'ငွေဝင်/ငွေထွက် စာရင်း',
      'အကြွေးစာရင်း',
      'Excel မှ ကုန်ပစ္စည်းနှင့်ဖောက်သည်ဒေတာတင်သွင်းမှု',
      'ပစ္စည်းအပိုင်းထုတ်ယူမှု',
      'မူကြမ်းဖန်တီးမှု',
      'ယူနစ်ပြောင်းလဲမှု',
      'ဘီလ်တစ်ခုတွင် ဓာတ်ပုံ ၁ ပုံသာပါဝင်သည်',
      'QR ကုဒ်ငွေပေးချေမှုအား ကန့်သတ်ခြင်း',
      'ဝဘ်ဗားရှင်း အခမဲ့သုံးစွဲမှု ၃ လ'
    ]
  },
  account: {
    systemSmartSubtitle: 'စမတ်ကျသော အရောင်းစီမံခန့်ခွဲမှုစနစ်',
    sendCodeSuccess: 'ကျွန်ုပ်တို့သည်အီးမေးလ်ကိုကိုဒ်နံပါတ်ဖြင့်ပို့လိုက်ပါပြီ။ သင့်အီးမေးလ်ကိုစစ်ဆေးပြီးအတည်ပြုမှုကိုဒ်နံပါတ်ရယူပါ။',
    errorCode: 'အတည်ပြုမှုကိုဒ်နံပါတ်မှားပါသည်',
    codeExpired: 'အတည်ပြုမှုကိုဒ်နံပါတ်ချိန်ကုန်သွားပါပြီ။',
    forgotPassword: 'စကားဝှက်မေ့နေပါသလား',
    enterEmail: 'သင့်အီးမေးလ်လိပ်စာထည့်ပါ',
    enterCode: 'အတည်ပြုမှုကိုဒ်နံပါတ်ထည့်ပါ',
    sendCode: 'အတည်ပြုမှုကိုဒ်နံပါတ်ပို့ပါ',
    submitCode: 'အတည်ပြုပါ',
    changePassword: 'စကားဝှက်ပြောင်းရန်',
    newPassword: 'စကားဝှက်အသစ်',
    renewPassword: 'စကားဝှက်အသစ်ကိုပြန်လည်ထည့်ပါ',
    password: 'စကားဝှက်',
    repassword: 'စကားဝှက်ကိုထပ်မံထည့်ပါ',
    register: 'စာရင်းသွင်းပါ',
    inputSoShort: 'အသုံးပြုသူအမည် သို့မဟုတ် စကားဝှက်သည်အတိုင်းအတာမပြည့်သည်',
    repassWrong: 'ပြန်လည်ထည့်သောစကားဝှက်မှားသည်',
    emailExist: 'အီးမေးလ်သည်ရှိပြီးသား',
    logout: 'ထွက်မည်',
    login: 'အကောင့်၀င်မည်',
    loginWithoutEmail: 'အီးမေးလ်မပါဘဲအကောင့်ဝင်မည်',
    loginWithoutEmailError: 'တည်ဆောက်ထားသောစက်ကုဒ်ကိုဖန်တီး၍မရပါ။ ထောက်ပံ့မှုနှင့်ဆက်သွယ်၍လမ်းညွှန်ချက်များကိုလေ့လာပါ။',
    offlineMode: 'အွန်လိုင်းမဟုတ်သောမode',
    offlineModeWarning:
      'အွန်လိုင်းမဟုတ်သောမode ကိုသုံးစွဲသောအခါ၊ ဒေတာသည်သင့်ပစ္စည်းတွင်သိမ်းဆည်းမည်ဖြစ်ပြီး၊ သင်သည်အကောင့်သို့၀င်ရန်လိုအပ်ပြီး၊ အခြားပစ္စည်းသို့ပြောင်းလဲသွားရန်မတိုင်မီဒေတာကိုဆုံးရှုံးမည်မဟုတ်ပါ။',
    logoutConfirmMessage: 'သင့်အကောင့်မှထွက်မည်ဟုသေချာပါသလား?',
    notFoundEmail: 'ဒီအီးမေးလ်နှင့်သက်ဆိုင်သောအကောင့်မရှိပါ',
    errorPassword: 'စကားဝှက်မှားပါသည်',
    emailInvalid: 'အီးမေးလ်မမှန်ကန်ပါ',
    titleRequest: 'ကျွန်ုပ်တို့သည်ဤအီးမေးလ်နှင့်ဆက်စပ်သောစကားဝှက်ပြောင်းလဲရန်တောင်းဆိုချက်ကိုလက်ခံခဲ့ပါပြီ။',
    enterCodeEmail: 'သင့်အီးမေးလ်သို့ပို့ထားသောအတည်ပြုကုဒ်ကိုထည့်ပါ'
  },
  statitical: {
    ...EN.statitical,
    chart: 'ဂရပ်',
    title: 'စီစဉ်မှု',
    sale: 'အရောင်း',
    debtBook: 'အကြွေးစာရင်း',
    revenue1: 'ဝင်ငွေ',
    revenue: 'အမြတ်',
    capital: 'ကုန်ကျစရိတ်',
    expense: 'အသုံးစရိတ်',
    saleToday: 'ယနေ့',
    sale7Days: '7 ရက်',
    sale30Days: '30 ရက်',
    chart7Days: 'နောက်ဆုံး 7 ရက်၏ဂရပ်',
    saleTitle: 'အရောင်းစီစဉ်မှု',
    revenueTitle: 'အမြတ်စီစဉ်မှု',
    orderTitle: 'အော်ဒါစီစဉ်မှု',
    returnOrderTitle: 'အော်ဒါပြန်လည်ပို့ခြင်းစီစဉ်မှု',
    order: 'အော်ဒါ',
    stock: 'စာရင်း',
    quantityOfInventory: 'ပစ္စည်းများ၏အရေအတွက်',
    quantityOfInventoryByCategory: 'အမျိုးအစားအလိုက်ပစ္စည်းများ၏အရေအတွက်',
    inventoryCapital: 'စာရင်းပိုင်ရာသိုလှောင်မှုပမာဏ',
    inventoryCapitalDetail: '(ယခင်ကိစ္စအချိန်တွင်ကုန်ကျစရိတ်အလိုက်ညီမျှသောမျိုး)',
    quantityOfInventoryProduct: 'စတိုးမှာရှိသောပစ္စည်းများ',
    saleOfStaff: 'ဝန်ထမ်း၏အရောင်း'
  },
  menu: {
    ...EN.menu,
    category: 'အမျိုးအစား',
    statitical: 'စီစဉ်မှု',
    version: 'ဗားရှင်း',
    other: 'အခြား',
    setting: 'ဆက်တင်',
    shortcut: 'လမ်းညွှန်',
    account: 'အကောင့်',
    feedback: 'ပြန်လည်တုံ့ပြန်မှု & အကြံပြုချက်',
    share: 'ဤအက်ပ်ကိုသူငယ်ချင်းများအားပို့ပါ',
    reportBug: 'အမှားအစီရင်ခံစာပို့ပါ',
    reportLogBug: 'မှားတယ်ဆိုသောရုပ်ပုံသို့ရောဂါမှတ်တမ်းပို့ပါ',
    policy: 'လုံခြုံရေးမူဝါဒ',
    term: 'အသုံးပြုမှုစည်းကမ်းများ',
    editProfile: 'ပရိုဖိုင်ပြင်ဆင်မှု',
    editProfileDetail: 'ဖောက်သည်၏အချက်အလက်များကိုပြင်ဆင်ပြီးဆိုင်အချက်အလက်များကိုတိကျစွာပြသပါ။',
    orderReturn: 'အော်ဒါပြန်လည်ပို့ခြင်း',
    support: 'ထောက်ပံ့မှု'
  },
  settingForStaff: {
    ...EN.settingForStaff,
    title: 'ဆိုင်ဆိုင်သတ်မှတ်ချက်များ',
    staff: 'စာရင်းဝန်ထမ်း',
    staffApp: 'ဝန်ထမ်းအတွက် အက်ပလီ케ရှင်း',
    branch: 'ဌာန',
    branchHint: 'ဤအစိတ်အပိုင်းသည် ၀န်ဆောင်မှုစီးပွားရေးအတွက်သာပါဝင်သည်။ ဥပမာ၊ အထက်ခန်း၊ အောက်ခန်း...',
    cafe: 'ကဖေ & အစားအသောက်',
    passForStaff: 'ဝန်ထမ်းအတွက် စကားဝှက်',
    passForStaffDetail: 'ဝန်ထမ်း၏ စတိုးအက်ပလီ케ရှင်းတွင် ဝင်ရောက်ရန် အသီးသီးသော စကားဝှက်။ အဓိက စကားဝှက်နှင့် တူညီမသင့်ပါ',
    mainBranch: 'အဓိက',
    addBranch: 'ဌာန အသစ် ထည့်ပါ',
    editBranch: 'ဌာန ပြင်ဆင်ပါ',
    addStaff: 'ဝန်ထမ်း အသစ် ထည့်ပါ',
    editStaff: 'ဝန်ထမ်း ပြင်ဆင်ပါ',
    table: 'စားပွဲ',
    branchName: 'ဌာန အမည်',
    branchTable: 'စားပွဲ အရေအတွက်',
    staffs: 'ဝန်ထမ်းများ စာရင်း',
    upgradeStaff: 'ခွင့်ပြုချက် တိုးမြှင့်ခြင်း',
    appForStaffIntro:
      'ဝန်ထမ်းအတွက် အက်ပလီကေးရှင်း စာရင်း၊ အဲဒီအက်ပလီကေးရှင်းကို သင့်ရဲ့ ဝန်ထမ်းများကို အော်ဒါ ပြုလုပ်ရန် အသုံးပြုနိုင်ပါသည်။ ဝန်ထမ်းအကောင့်ဖွင့်ရန်လိုအပ်ပြီး ဒေတာကို သင့်အဓိကအကောင့်ထံ ပေါင်းစည်းထားပါမည်။',
    emailExist: 'ဝင်ရောက်ခွင့်အီးမေးလ် ရှိပါသည်',
    shopType: 'စီးပွားရေးအမျိုးအစား',
    grocery: 'အိုးအိတ်၊ ဆိုင်',
    appForStaff: ['aSeller ဝန်ထမ်းအက်ပလီကေးရှင်း'],
    appForStaffDetail: ['ဆိုင်၊ ကဖေ၊ ရေချိုးခြင်း၊ တာပါ၊ ဆိုင်ကြီးသို့ အများဆုံးသုံးသည့်အက်ပလီကေးရှင်းဖြင့် အသုံးပြုပါ'],
    shopTypeDetail: 'ဤသင့်ရဲ့ စီးပွားရေးအမျိုးအစားကို သင့်ဝန်ထမ်းအက်ပလီကေးရှင်း၏ မော်ဒယ်ကို အလိုက်သင့်လုပ်ကိုင်ပုံကို ရွေးချယ်ပါ',
    showCustomer: 'ဝန်ထမ်းတွင် ဖောက်သည်များကို ဖော်ပြပါ',
    showCustomerDetail: 'ဝန်ထမ်းအက်ပလီကေးရှင်းတွင် ဖောက်သည်စာရင်းကို ဖော်ပြပါ',
    customerShowMode: ['အားလုံးကို ဖော်ပြပါ', 'ဝန်ထမ်း၏ ဖောက်သည်များသာ ဖော်ပြပါ', 'ဖော်ပြမည်မဟုတ်ပါ'],
    upgradeStaffContact: 'ဝန်ထမ်းအတွက် အခွင့်ပြုချက် ရောင်းချလိုပါကဆက်သွယ်ပါ',
    service: 'ဝန်ဆောင်မှု',
    serviceDetail: 'ကဖေ၊ အစားအသောက်၊ တာပါ',
    retail: 'လက်မှတ်',
    retailDetail: 'ဆိုင်၊ အဆက်အသွားများ',
    showStatistial: 'သုံးသပ်ချက် ကို ပြသပါ',
    showStatistialDetail: 'ဝန်ထမ်းအားလုံးကို ၇ ရက်တာ စာရင်းပြသပါ',
    stockEnabled: 'ဝန်ထမ်းအတွက် သိုလှောင်မှု ပြသပါ',
    stockEnabledDetail: 'အဆင်ပြေသော တင်ထားသော ရောင်းသောပစ္စည်းများကို အပီများ၊ ပါရီရှင်းများကို ကြည့်ပါ',
    uiForStaft: 'ဝန်ထမ်းအတွက် UI',
    uiForStaftDetail: 'သင့်ဝန်ထမ်းများအတွက် လွယ်ကူသော UI များဖြင့် ရွေးချယ်ပါ'
  },
  prefix: {
    title: 'အလျော်ကူးမဟုတ်',
    detail: 'စတင်ခြင်းမှာ အော်ဒါ၊ ထုတ်ကုန်၊ .. ကြည့်ရှုနေပုံများ'
  },
  setting: {
    customerCanRegister: 'ဖောက်သည်များအကောင့်စာရင်းသွင်းရန် ခွင့်ပြုပါ',
    customerCanRegisterDetail: 'ဖောက်သည်များသည် သူတို့ကိုယ်တိုင် အကောင့်စာရင်းသွင်းနိုင်ပါသည်။ ဖွင့်ပါက ထုတ်ကုန်ဈေးနှုန်းသည် ဖောက်သည်အားလုံးအတွက် ထုတ်ပြန်မည်ဖြစ်သည်။',
    vote: 'အက်ပ်ကို အကဲဖြတ်ပါ!',
    about: 'အကြောင်း',
    title: 'ထုတ်ကုန်ပေါင်းသင်းရေးစနစ်',
    help: 'အသုံးပြုနည်း',
    currency: 'ငွေပမာဏ',
    timeFormat: 'နေ့ရက်အမျိုးအစား',
    oddNumber: 'နံပါတ်ခွဲသုံးရခြင်းကို အသုံးပြုပါ',
    oddNumberEx: 'ဥပမာ 1000.15VNĐ, 0.5KG...',
    sync: 'ဒေတာ',
    login: 'လျှောက်ထားပါ',
    logout: 'ထွက်ပါ',
    notSignin: 'မဝင်ရောက်ပါ',
    syncIntro: 'သင်၏ Google အကောင့်ကို ဝင်ရောက်၍ သင့်ဒေတာကို အထောက်အကူပြု၍ ကူးယူပေးမည်၊ အခြားသော စက်တွင်လည်း ပြောင်းရွှေ့နိုင်ပါသည်',
    syncNow: 'ယခု ကူးယူပါ',
    lastSync: 'နောက်ဆုံးကူးယူမှုအချိန်',
    restore: 'ဒေတာပြန်လည်ကူးယူပါ',
    requireLogin: 'ဤလုပ်ဆောင်ချက်ကို ပြုလုပ်ရန် Google အကောင့်ဝင်ရောက်ပါ',
    syncNotFound: 'မည်သည့်ကူးယူမှုကိုမှ မတွေ့ရှိပါ',
    confirmSync: 'ဆာဗာပေါ်ရှိ ဒေတာများသည် မရိုးမကျ မလိုက်ဖက်ရင်ဖြင့် သင်ကူညီလိုက်မည်နည်း?',
    confirmRestore: 'သင်ရရှိထားသောဒေတာကို ပြန်လည်သုံးစွဲရန် သင့်လက်ရှိဒေတာသည် ပေါင်းစပ်ခံရမည်၊ သင်နှစ်သက်ပါသလား?',
    loginExpired: 'သင်၏ ဝင်ရောက်အကြာအမြင့် ကုန်ဆုံးနေပါသည်။ ကျေးဇူးပြု၍ ထပ်မံဝင်ရောက်ပါ',
    autoBackup: 'ဒေတာကို အလိုအလျောက် ကူးယူပါ',
    googleAccountConnect: 'Google အကောင့်',
    on: 'ဖွင့်ပါ',
    off: 'ပိတ်ပါ',
    googleLogoutConfirm: 'သင် Google အကောင့်မှ ထွက်ပါ့မလား?',
    print: 'ပရင်တာချိတ်ဆက်ခြင်း',
    printDetail: 'သင့် Bluetooth ပရင်တာကို ရွေးချယ်ပြီး သင့်ထုတ်ကုန်ဈေးစာရင်းနှင့် ပုံမှန်ပေါ်ဖွင့်ပါ',
    connectPrinter: 'ပရင်တာ',
    invoice: 'ငွေတောင်းခံစာ',
    invoiceHello: 'ကျေးဇူးတင်စာ',
    surchargeText: 'ငွေချေမှုရှိသောငွေပမာဏပြောင်းလဲခြင်း',
    invoiceSignature: 'လက်မှတ်ပြပါ',
    invoiceDebt: 'ထိုက်တန်ပြတ်တဲ့ အကြွေးပြုပြင်ခြင်း',
    invoiceDebtInfo: 'လိပ်စာ ပေါင်းစပ်ပြီးငွေပမာဏသို့တည်တံတားပြောင်းခြင်း',
    debt: 'ကျိန်စာ',
    invoiceDebtDetail: 'ကျိန်စာ ပြချက်',
    invoiceDebtDetailDetail: 'ယင်းတွင်ပါသောအထွတ်အထိ လုပ်ငန်းအကြွေး',
    invoiceDiscount: 'လျှော့စျေးဖြင့်ဖြစ်သွားပါပြီ',
    invoiceHelloDetail: 'ဖောက်သည်အတွက်ကျေးဇူးတင်စာ ပြင်ဆင်ပါ',
    warningOutStock: 'ပစ္စည်းရောင်းသွားပါ',
    warningOutStockDetail: 'ရောင်းလိုသောပစ္စည်းများကုန်ဆုံးပါကသင် ညွှန်ကြားပါ',
    warningOutStockMessage: 'သင်၏ပစ္စည်းအတွက်ကုန်ဆုံးပါသည်၊ တခြားအလားတူလို့ ရွေးချယ်ပြီး ပစ္စည်းကို ထပ်မံထည့်ပါ။',
    showRevenue: 'ငွေကြေးနှင့်ငွေကြေးအဆင့်ပြသာ',
    orderStatus: 'အော်ဒါအဆင့်များပြသပါ',
    orderStatusDetail: 'အော်ဒါ အစမ်းအားတွင်တင်တဲ့အရာကို "လုပ်ငန်းဆောင်ရွက်နေသည်" များမည်မျှဖြစ်ပါမယ်။',
    showHomeRevenue: 'အခန်းဝင်တန်ဖိုး',
    showHomeChart: 'အချိန်ပိုင်း',
    showHomeFinancial: 'ငွေကြေးပြုလုပ်ပါ',
    showHomeStatistial: 'ဝန်ဆောင်မှုများကိုလည်းမြင်ရပါ',
    averageBuyPrice: 'အကောင်းဆုံးစျေးပေါ်ပြီ',
    averageBuyPriceDetail: 'သင့်ဈေးပေါ်သောဆင်းကတော့မှောက်မှစွပ်ရစ်ဖြစ်ပါသည်၊ မပါနှစ်မှုများ',
    bankInfo: 'ဘဏ်အချက်',
    vietQRCode: 'QR Code',
    vietQRCodeDetail: 'လျှောက်ပန်ယာလ်ရှုယူမှု',
    vietQRCodeWarning: 'အကောင်းဆုံးမေးလ်'
  },
  customer: {
    ...EN.customer,
    id: 'ဖောက်သည်ကုဒ်',
    prefix: 'ဖောက်သည်ကုဒ်အစိတ်',
    title: 'ဖောက်သည်',
    create: 'ဖောက်သည်အသစ်ထည့်ပါ',
    name: 'ဖောက်သည်အမည်',
    address: 'လိပ်စာ',
    phone: 'ဖုန်းနံပါတ်',
    email: 'အီးမေးလ်',
    add: 'ဖောက်သည်အသစ်ထည့်ပါ',
    choice: 'ဖောက်သည်ရွေးချယ်ပါ',
    invalidPhoneOrAddress: 'ဖုန်းနံပါတ် သို့မဟုတ် လိပ်စာ ထည့်ပေးပါ',
    phoneExist: 'ဤဖုန်းနံပါတ်သည် ရှိပြီးပါသည်',
    search: 'အမည် သို့မဟုတ် ဖုန်းနံပါတ် ဖြင့် ရှာဖွေပါ',
    free: 'အခမဲ့ ဖောက်သည်',
    orderStatistics: 'အမိန့်စာရင်း統計',
    exportDebt: 'ကန့်သတ်တစ်ခါ ချေးငွေ ထုတ်ယူရန်',
    addDebt: 'ချေးငွေ ထည့်ပါ',
    yearOld: 'အသက်',
    countBirthDay: 'နေ့ရက် %s ကျန်ရှိပါသည်',
    createScreen: {
      taxCodeNotFound: 'အခွန်ကုဒ်အချက်အလက် မတွေ့ပါ',
      avatarLabel: 'ပရိုဖိုင်ပုံ',
      contactHint: 'ဖုန်းစာအုပ်မှ အချက်အလက်မြန်မြန်ဖြည့်နိုင်ပြီး ပရိုဖိုင်ပုံထည့်နိုင်သည်',
      basicInfoTitle: 'အခြေခံအချက်အလက်'
    }
  },
  order: {
    lastPrice: 'နောက်ဆုံးဈေး',
    lastPriceAuto: 'နောက်ဆုံးရောင်းဈေးကို အလိုအလျောက်သုံးရန်',
    lastPriceAutoDetail: 'ဖောက်သည်၏ အော်ဒါများတွင် လက်လီဈေးအစား ထိုဖောက်သည်ထံ နောက်ဆုံးရောင်းခဲ့သောဈေးကို အလိုအလျောက်သုံးမည်',
    ...EN.order,
    editDeadline: 'အမိန့်ပြင်ဆင်ခွင့်ကာလ',
    editDeadlineDetail: 'အမိန့်ဖန်တီးသည့်နေ့မှစ၍ ဤရက်အရေအတွက်အတွင်း အမိန့်ကို ပြင်ဆင်နိုင်သည်။',
    editDeadlineExpired: 'အမိန့်ပြင်ဆင်ခွင့်ကာလ ကျော်လွန်သွားပါပြီ။ "ဆက်တင်များ" -> "အမိန့်ဆက်တင်များ" တွင် အမိန့်ပြင်ဆင်ခွင့်ကာလကို ပြောင်းလဲပါ။',
    id: 'အမိန့်ကုဒ်',
    prefix: 'အမိန့်ကုဒ်အစိတ်',
    title: 'ရောင်းဝယ်ရေးအမိန့်',
    create: 'ရောင်းဝယ်ရေးအမိန့် ထည့်ပါ',
    edit: 'အမိန့် ပြင်ဆင်ပါ',
    detail: 'အမိန့်အသေးစိတ်',
    exportInvoice: 'ငွေပေးချေမှုလွှာ',
    add: 'ပစ္စည်း ထည့်ပါ',
    infoShop: 'ဆိုင်အချက်အလက်',
    invalidCustomer: 'ဖောက်သည်အချက်အလက် ရွေးချယ်ပါ',
    invalidProduct: 'အမိန့်တွင် ပစ္စည်းမရှိပါ',
    confirmDelete: '%s ကို ဖျက်လိုပါသလား?',
    search: 'အမိန့်ကုဒ်၊ အမည် သို့မဟုတ် ဖောက်သည်ဖုန်းနံပါတ်ဖြင့် ရှာဖွေပါ',
    discount: 'လျော့ဈေး',
    realPrice: 'စစ်မှန်သောဈေး',
    discount1: 'လျော့ဈေး (လျော့ဈေး)',
    inStockNotEnough: 'ကုန်ပစ္စည်းအရေအတွက် မလုံလောက်ပါ။ ထပ်တိုးပါ',
    createFailed: 'အမိန့် ဖန်တီးရန် မအောင်မြင်ပါ။ ပြန်လည်ရယူပါ',
    surcharge: 'ထပ်မံခွဲခြား',
    surchargeDetail: '(ပို့ဆောင်ခ၊ အခွန်၊ အကြွေးများ...)',
    barcodeNotFound: 'ဤbarcode ကုဒ် မရှိပါ။ ပစ္စည်းထည့်ပြီးမှ အမိန့်တွင် ထည့်ပါ',
    price: 'ဈေး',
    customPrice: 'စိတ်ကြိုက်ဈေး',
    customPrice1: 'စုစုပေါင်းဈေး% လျော့ထားပါ',
    orderMoneyUpdated: 'အမိန့်ဈေးမြင့်တင်ထားပါသည်',
    totalProductMoney: 'စုစုပေါင်းပစ္စည်းဈေး',
    totalMustPaidMoney: 'စုစုပေါင်း ငွေပြန်ပေးရမည်',
    totalMustPaidMoneyForCustomer: 'ဖောက်သည်အား ပေးရန်ငွေစုစုပေါင်း',
    totalPaidMoney: 'လွှဲငွေ',
    totalDebtMoney: 'ဖောက်သည်အကြွေး',
    paid: 'ပေးဆောင်ပြီး',
    totalLiabilities: 'စုစုပေါင်းအကြွေး',
    totalPaidMoneyForCustomer: 'ဖောက်သည်ကို ပေးပါ',
    providerRefunds: 'ပေးပို့သူထုတ်ပေးသည်',
    providerDebt: 'ပေးပို့သူအကြွေး',
    pointDiscount: 'အမှတ်လျော့ဈေး',
    money: 'အမိန့် ငွေစုစုပေါင်း',
    statusOffRequire: 'အမိန့်အခြေအနေ ပိတ်ထားပါ',
    statusOffRequireDetail: 'အမိန့်အခြေအနေ ပိတ်ထားရမည်။ မဟုတ်ပါက ကျေးဇူးပြု၍ ဤလုပ်ဆောင်ချက်ကိုသုံးမည်ဆိုပါက အမှတ်တံဆိပ်လျော့နည်းမှု ဖြစ်နိုင်ပါသည်',
    surchargeType2: 'အရောင်းသူ ပေးဆောင်မည်',
    surchargeType1: 'ဝယ်သူ ပေးဆောင်မည်',
    surchargeTypeHint: '- ဝယ်သူ ပေးဆောင်: အရောင်းငွေစာရင်းတွင် တွက်ချက်ပါ၊ ရင်းနှီးမြှုပ်နှံမှုမှာ ထည့်ခြင်းမရှိပါ\n- အရောင်းသူ ပေးဆောင်: ဤပစ္စည်း ထဲမှာ စိတ်ကြိုက်သွင်းမှုမရှိပါ'
  },
  product: {
    ...EN.product,
    multiStopSale: 'အများအပြား ရောင်းချမှုရပ်ဆိုင်းရန်',
    multiSale: 'အများအပြား ရောင်းချရန်',
    stopSale: 'ရောင်းချမှုရပ်ဆိုင်းရန်',
    sale: 'ရောင်းချရန်',
    stopSaleList: 'ရောင်းချမှုရပ်ဆိုင်းထားသောစာရင်း',
    saleList: 'ရောင်းချနေသောစာရင်း',
    id: 'ကုန်ပစ္စည်းကုဒ်',
    prefix: 'ကုန်ပစ္စည်းကုဒ်အစိတ်',
    title: 'ကုန်ပစ္စည်း',
    create: 'ကုန်ပစ္စည်း အသစ်ထည့်ပါ',
    add: 'ကုန်ပစ္စည်း အသစ်ထည့်ပါ',
    choice: 'ကုန်ပစ္စည်း ရွေးချယ်ပါ',
    name: 'ကုန်ပစ္စည်းအမည်',
    priceType: 'ဈေးနှုန်းရွေးချယ်ပါ',
    price: 'ကုန်ပစ္စည်းဈေး',
    buyPrice: 'ဝယ်ဈေး',
    sellPrice: 'လျှော့ဈေး',
    sellPrice1: 'အထူးပရိုမိုးရှင်းဈေး',
    sellPrice2: 'ရောင်းစျေး',
    recent: 'သုံးလွန်လာသော ကုန်ပစ္စည်း',
    search: 'ကုဒ်နှင့်အမည်ကိုအလိုက် ရှာဖွေပါ',
    sold: 'ရောင်းပြီး',
    inStock: 'ကုန်ပစ္စည်းရောင်းရှိ',
    initStock: 'ပစ္စည်းစတင်အရေအတွက်',
    initStockDetail: 'ကုန်ပစ္စည်းအသစ်တင်ပါက စတင်အသေးစိတ်',
    vatDetail: 'အခွန်ခွဲဖြင့်ဝယ်လျှင်',
    vat: 'VAT',
    expirationDate: 'သက်တမ်းကုန်ဆုံးရက်',
    outOfStock: 'ကုန်ပစ္စည်းမရှိ',
    barcode: 'barcode',
    exist: 'ကုန်ပစ္စည်းသည် ရှိပြီးပါသည်။ နာမည်သို့မဟုတ် barcode ကိုစစ်ဆေးပါ',
    canNotDelete: 'ဤကုန်ပစ္စည်းကို ဖျက်နိုင်ခြင်းမရှိပါ၊ အမိန့်ရှိနေသောကြောင့် ပြန်လည်ဖျက်ရန်လိုအပ်သည်',
    errorPrice: 'ရောင်းဈေး သို့မဟုတ် ဝယ်ဈေး မမှန်ကန်ပါ',
    changeSellPriceWarning: 'သတိပြုပါ: ရောင်းဈေးပြောင်းလဲလျှင် အမိန့်များအပေါ် ထိရောက်မှုရှိသည်',
    changeSellPriceWarningDetail: 'ရောင်းဈေးပြောင်းလဲလျှင် လက်ရှိအမိန့်များတွင် အထိရောက်ပါလိမ့်မည်။ သင်သည် ၎င်းကိုပြောင်းလဲရန် တကယ့်လိုအပ်ပါသလား?',
    deleteNumProduct: '%s ကုန်ပစ္စည်းဖျက်ပါ',
    deleteNumProductConfirm: '%s ကုန်ပစ္စည်းကို ဖျက်ချင်ပါသလား?',
    hiddenNumProduct: '%s ကုန်ပစ္စည်းကို ရောင်းချမှုရပ်ဆိုင်းပါ',
    activeNumProduct: '%s ကုန်ပစ္စည်းကို ရောင်းချပါ',
    hiddenNumProductConfirm: '%s ကုန်ပစ္စည်းကို ရောင်းချမှုရပ်ဆိုင်းမည်ဟု သေချာပါသလား?',
    activeNumProductConfirm: '%s ကုန်ပစ္စည်းကို ရောင်းချမည်ဟု သေချာပါသလား?',
    canNotDeleteProduct: 'အမိန့်ရှိသောကြောင့် ၎င်းကုန်ပစ္စည်းကို ဖျက်မည် မဟုတ်ပါ',
    syncAmount: 'ကုန်ပစ္စည်းအရေအတွက်ကို တိကျစွာရေတွက်ပါ',
    syncAmountConfirm: 'ကုန်ပစ္စည်းအရေအတွက် %s မှတဆင့် လုပ်ဆောင်ပါ။',
    barcodeExist: 'barcode နဲ့ကိုက်ညီတဲ့ အခြားကုန်ပစ္စည်းတစ်ခုရှိပါတယ်',
    type: 'ပစ္စည်းအမျိုးအစား',
    type1: 'အမျိုးအစား (Size, အရောင်...)',
    typeHint: 'အမျိုးအစားအမည်',
    sku: 'skuကုဒ်',
    skuExist: 'sku နေရာမှာရှိပြီးပါသလား',
    image: 'ပစ္စည်းပုံ',
    nameSoShort: 'အမည်သည် ၄ ပုဒ်ထက် ပိုမြင်သာရှိရမည်',
    nameExist: 'အမည်အတူတူရှိပါတယ်',
    canNotCreateUnitConvertWithType: 'ပစ္စည်းမျိုးစုံအသုံးပြုနိုင်ခြင်းမရှိ',
    limitUploadImage: 'အသုံးပြုသူအချိုးမှန်ပုံများကိုတင်နိုင်ပါသည်',
    limitContentLength: 'ပစ္စည်းစာရွက်အမျိုးအစားမှတ်ပြီး',
    limitImageOffline: 'Offline ထဲမှ နေရာသစ် ၂ ထည်မှန်ပေးပါ',
    importNewFromExcel: 'ဤထည့်ရတဲ့ Excel မှာ ဆောင်းတင်ပါ',
    importUpdateFromExcel: 'လုပ်ဆောင်မည်'
  },
  category: {
    id: 'ကဏ္ဍကုဒ်',
    prefix: 'ကဏ္ဍကုဒ်အစိတ်',
    title: 'ကုန်ပစ္စည်းအမျိုးအစား',
    create: 'အမျိုးအစားအသစ်ထည့်ပါ',
    name: 'အမျိုးအစားအမည်',
    choice: 'အမျိုးအစားရွေးချယ်ပါ',
    search: 'ကုဒ်နှင့်အမည်အလိုက် ရှာဖွေပါ',
    categoryExist: 'အမျိုးအစားအမည်ရှိပြီးပါသည်',
    choiceProduct: 'ကုန်ပစ္စည်းများကို အမျိုးအစားထဲသို့ ထည့်ပါ'
  },
  importOrder: {
    id: 'အမိန့်ကုဒ်',
    prefix: 'အမိန့်ကုဒ်အစိတ်',
    title: 'ကုန်ပစ္စည်းထည့်သွင်းခြင်း',
    detail: 'ကုန်ပစ္စည်းထည့်သွင်းခြင်းအသေးစိတ်',
    create: 'အမိန့်အသစ်ထည့်ပါ',
    edit: 'အမိန့်ကိုပြင်ဆင်ပါ',
    editProductPrice: 'ကုန်ပစ္စည်းဈေးပြောင်းပါ',
    editProductPriceWarning: 'ဤကုန်ပစ္စည်း၏ ဝယ်ဈေးကို %s သို့ ပြောင်းလဲလိုပါသလား?'
  },
  importReturnOrder: {
    id: 'အမိန့်ကုဒ်',
    prefix: 'အမိန့်ကုဒ်အစိတ်',
    title: 'ကုန်ပစ္စည်းပြန်အမ်းခြင်း',
    detail: 'ကုန်ပစ္စည်းပြန်အမ်းခြင်းအသေးစိတ်',
    create: 'အမိန့်ပြန်လည်ထည့်ပါ',
    edit: 'အမိန့်ကိုပြင်ဆင်ပါ'
  },
  provider: {
    id: 'ပံ့ပိုးပေးသူကုဒ်',
    prefix: 'ပံ့ပိုးပေးသူအစိတ်',
    title: 'ပံ့ပိုးပေးသူ',
    create: 'ပံ့ပိုးပေးသူအသစ်ထည့်ပါ',
    name: 'ပံ့ပိုးပေးသူအမည်',
    choice: 'ပံ့ပိုးပေးသူရွေးချယ်ပါ',
    search: 'ကုဒ်၊ အမည်၊ ဖုန်းနံပါတ်အလိုက် ရှာဖွေပါ',
    categoryExist: 'ပံ့ပိုးပေးသူအမည်ရှိပြီးပါသည်',
    order: 'အမိန့်',
    free: 'သတ်မှတ်မထား'
  },
  googleDriver: {
    loginGoogle: 'ဤလုပ်ဆောင်ချက်ကို ဆောင်ရွက်ရန် Google အကောင့်သို့ အဝင်လိုအပ်ပါသည်',
    backup: 'အကောက်လှမ်း',
    backupToDriver: 'အကောက်လှမ်း',
    backupSuccess: 'အကောက်လှမ်းအောင်မြင်ပါသည်',
    backupError: 'အကောက်လှမ်း မအောင်မြင်ပါ',
    emptyBackup: 'ဘက်ကပ်မရှိပါ',
    loadingBackupFile: 'အကောက်လှမ်းဖိုင်ကိုတင်နေပါသည်',
    backingUp: 'အကောက်လှမ်းနေပါသည်',
    restore: 'ပြန်လည်သိမ်းဆည်း',
    restoreFromDriver: 'ပြန်လည်သိမ်းဆည်း',
    restoreSuccess: 'အချက်အလက်ပြန်လည်သိမ်းဆည်းပြီးပါပြီ',
    restoring: 'ပြန်လည်သိမ်းဆည်းနေပါသည်',
    resetData: 'ဒေတာကို ပြန်လည်စတင်ပါ',
    resetDataDetail: 'ဒေတာအားလုံးကို ပြန်လည်စတင်ပါ',
    resetDataConfirm: 'ယခုအချိန်တွင် အချက်အလက်များကို ဖျက်မလား?',
    backupErrorCaseInvalidToken: 'အကောက်လှမ်းမရပါ၊ Google အကောင့်လက်မှတ်ပြီးဆုံးပါသည်။ အကောင့်မှ တက်လှမ်းပြီး ပြန်လည်ကြိုးစားပါ!',
    confirmReplaceOlderTitle: 'အသစ်တင်မည်ဟု အတည်ပြုပါ',
    confirmReplaceOlderDetail: 'Google Driver တွင် ဒေတာဗားရှင်းအသစ်တစ်ခု ရှိပါသည်။ ယခု ဒေတာကို အကောက်လှမ်းလား?',
    restoreChoose: 'သိမ်းဆည်းလိုသော ဒေတာကို ရွေးချယ်ပါ',
    backupRename: 'အမည်သက်မှတ်ပါ',
    backupAt: 'အကောက်လှမ်းအချိန်'
  },
  staffUpgrade: {
    upgradeForStaff: 'သင်သည် ဝန်ထမ်းအတွက် အဆင့်မြှင့်တင်မှုလုပ်နေပါသည်။ သင်သည် ပိုပြီးအတည်ပြုမှုမရှိဘဲ ပေးဆောင်ပြီးသား ဖြစ်ပါက ပြန်လည်ပေးဆောင်ခြင်းကို ရွေးချယ်ပါ။',
    staff1m: 'တစ်လအပိုတိုးချဲ့ပါ',
    staff6m: 'ခြောက်လအပိုတိုးချဲ့ပါ',
    staff1y: 'တစ်နှစ်အပိုတိုးချဲ့ပါ'
  },
  proVersion: {
    ...EN.proVersion,
    pro: 'အထူးဝန်ဆောင်မှုအထူးပကတိ',
    proDetail:
      'အထူးဝန်ဆောင်မှုအထူးပကတိ သည် အပလီကေးရှင်း၏ အပြည့်အစုံသော လုပ်ဆောင်ချက်များကို အသုံးပြုနိုင်သော အထူးပကတိ ကိရိယာ (ဝန်ထမ်းအကောင့်နှင့် ဖွံ့ဖြိုးတိုးတက်သော အခြားအရပ်များ မပါဝင်ပါ) ဖြစ်သည်။ အသေးစိတ်များကို "အခမဲ့ - အထူးပကတိ နှိုင်းယှဉ်ပါ" ကိုနှိပ်ပါ',
    staffAcc: 'အထူးပကတိ ဝန်ထမ်းအကောင့်',
    staffAccDetail:
      'လုပ်ငန်းတစ်ခုတွင် ဝန်ထမ်းအကောင့် အသုံးပြုလိုသော အထူးပကတိ စီမံကိန်းဖြစ်သည်။ ပထမအကောင့်အတွက် ၆ လ အခမဲ့ပေးအပ်ပါသည်။ တစ်ဝန်ထမ်းအကောင့်သည် ထောက်ပံ့ပေးသည့် ကိရိယာအများအတွက် ဝင်ရောက်နိုင်ပါသည်',
    warehouseExt: 'အထူးပကတိ ရှုပ်ထွေးထားသော အဆောက်အဦး',
    warehouseExtDetail: 'ဒုတိယခွဲအနေဖြင့် ရှုပ်ထွေးခြင်း ရှိသည်။ ဒုတိယခွဲသည် တစ်လအတွက် အခမဲ့ အသုံးပြုနိုင်ပါသည်',
    linked: 'လက်တွေ့ချိတ်ဆက်ပြီးပါသည်',
    paymentRecoveryHint: 'သင်၏ အကောင့်အတွက် ပေးဆောင်မှုကို ပြန်လည်သက်တမ်းဖြည့်ပါ!',
    name: 'အထူးပကတိဗားရှင်း',
    detail: 'သင်အထူးပကတိ ဂျစ်ဗားရှင်းကို ဝယ်ယူသည့်အခါ သွားကြမည့် ပြောင်းလဲမှုများ',
    removeAds: 'အထူးပကတိဗားရှင်း ဝယ်ယူပါ',
    removeAdsDetail: 'သင်သည် ၁ ကြိမ်ပေးဆောင်မှုပင်သာ လိုအပ်ပြီး၊ နောက်ထပ်အကြိမ်များအတွက် သက်တမ်းပြန်လည်ဖြည့်ပါလိမ့်မည်',
    paymentRecovery: 'ပေးဆောင်မှု ပြန်လည်ဖွဲ့တည်းရန်',
    paymentRecoveryDetail: 'အထူးပကတိ ဂျစ်ဗားရှင်းအတွက် ပေးဆောင်မှုကို ပြန်လည်တင်ပြပါ',
    purchaseFailed: 'ပေးဆောင်မှု မအောင်မြင်ပါ။ ပြန်လည်ကြိုးစားပါ',
    purchaseSuccess: 'ပေးဆောင်မှု အောင်မြင်ပါသည်။ ကျေးဇူးတင်ပါသည်!',
    recoveryPaymentSuccess: 'ပေးဆောင်မှု ပြန်လည်ပြုလုပ်ခြင်း အောင်မြင်ပါသည်!',
    recoveryPaymentUnsuccess: 'ပေးဆောင်မှု ပြန်လည်ပြုလုပ်ခြင်း မအောင်မြင်ပါ။ ကျေးဇူးပြု၍ ပြန်လည်ကြိုးစားပါ',
    recoveryIfNeed: 'သင်သည် ပေးဆောင်ပြီးနောက် အဆင့်မြှင့်တင်မှု မဖြစ်ခဲ့ပါက ပြန်လည်ပြုလုပ်ခြင်းကို ရွေးချယ်ပါ',
    cancelIfNeed: 'သင်သည် အလိုအလျောက် ထွက်ပြေးခြင်းကို ပယ်ဖျက်လိုပါက %s မှာ အဆင့်မြှင့်တင်ချက်ကို ရှာဖွေပါ',
    cancelSubsiOS: `iPhone တွင် အလိုအလျောက် လွှတ်ခွင့် ရှာဖွေခြင်းကို တင်ပြပါ
    - iPhone တွင် "Setting" ကိုဖွင့်ပါ
    - သင့်အမည်ပေါ် ကိုနှိပ်ပါ
    - "Subscription" ကိုနှိပ်ပါ
    - iPhone တွင် "Subscription" မီနူးများပေါ်လာပါသည်
    - သင်နှိပ်လိုသော Subscribed Plan ကိုဖွင့်ပါ
    - "Unsubscribe" ကိုနှိပ်ပါ`,
    cancelSubsAndroid: `Android ဖုန်းတွင် ၃ သုံးခြင်းကို သွားရှာလို့
    - Android ရဲ့ Google Play App ကိုဖွင့်ပါ
    - ဂေါ်ဂဲလ်အကောင့်နံပါတ်ကိုနှိပ်ပါ
    - "Subscriptions" ကိုထည့်ပါ
    - မိမိလိုနှစ်ဆင့်တင်မယ့် Subscription ကိုရှာဖွေပါ
    - ရွေးထား၍၊ Unsubscribe ကိုနှိပ်ပါ`,
    canSubs: 'သင့်ကို မလိုအပ်သောလွှတ်ခွင့်',
    expireDate: 'သက်တမ်းကုန်ဆုံး',
    expired: 'သက်တမ်းကုန်ဆုံးပါပြီ',
    yourPackage: 'သင်သည် အထူးပကတိ ဂျစ်ဗားရှင်းကို အသုံးပြုနေပါသည်',
    packageFull: 'ရှည်လျားသော Package',
    trial: '7 ရက် သုံးစွဲခြင်း',
    trialDetail: 'အထူးပကတိဂျစ်ဗားရှင်းကို 7 ရက်အထိ အသုံးပြုနိုင်ပါသည်။ \nသင်၏ အချိန်ကုန်ဆုံးပြီးနောက် အခမဲ့ဂျစ်ဗားရှင်းအတွက် ပြန်လည်ပြောင်းလဲပါမည်',
    package1M: 'တစ်လ Package',
    package3M: 'သုံးလ Package',
    package6M: 'ခြောက်လ Package',
    package1Y: 'တစ်နှစ် Package',
    package5Y: 'ငါးနှစ် Package',
    package10Y: 'ပေါင်း ၁၀ နှစ် Package',
    package1MDetail: 'တစ်လ Package ကို အသုံးပြုသည်။ \nပေးပို့ရန် အလိုအလျောက် ချိန်ညှိပါ',
    package3MDetail: 'သုံးလ Package ကို အသုံးပြုသည် \nအချိန်ကုန်ဆုံးမူလ မိမိပေါ်လွင်သည်',
    package6MDetail: 'ခြောက်လ Package ကို အသုံးပြုသည် \nအချိန်ကုန်ဆုံးမှာ ပရိုဂရမ်ကို ပြန်လည်ထည့်ချင်ပါမည်',
    package1YDetail: '၁ နှစ်ကြာ အထူးပကတိ ဂျစ်ဗားရှင်းကို အသုံးပြုပါ။\nအဆိုပါ ဂျစ်ဗားရှင်း သည် အချိန်တိုးခြင်းကို ပေါင်းစပ်နိုင်ပြီး အလိုအလျောက် အဆင့်မြှင့်တင်ခြင်းမရှိပါ',
    package5YDetail: '၅ နှစ်ကြာ အထူးပကတိ ဂျစ်ဗားရှင်းကို အသုံးပြုပါ။\nအဆိုပါ ဂျစ်ဗားရှင်း သည် အချိန်တိုးခြင်းကို ပေါင်းစပ်နိုင်ပြီး အလိုအလျောက် အဆင့်မြှင့်တင်ခြင်းမရှိပါ',
    package10YDetail: '၁၀ နှစ်ကြာ အထူးပကတိ ဂျစ်ဗားရှင်းကို အသုံးပြုပါ။\nအလိုအလျောက် အဆင့်မြှင့်တင်ခြင်းမရှိပါ',
    packageWarehouse1Y: '၁ နှစ်ကြာ ကုန်ဂရုနှင့်အတူကွယ်လွန်ခြင်း',
    packageWarehouse1YDetail: 'ကုန်စုံစံကို ထပ်မံလက်ခံပါ - ၁ နှစ်ကြာ အချိန်တိုးခြင်း။\nအလိုအလျောက် အဆင့်မြှင့်တင်ခြင်းမရှိပါ',
    packageStaff1Y: 'ဝန်ထမ်း ၁ နှစ်',
    packageStaff1YDetail: 'ဝန်ထမ်းအကောင့်ကို ၁ နှစ်အထိ အသုံးပြုနိုင်ပါသည်။\nအလိုအလျောက် အဆင့်မြှင့်တင်ခြင်းမရှိပါ',
    serviceFee: 'ဝန်ဆောင်မှုကြေး',
    serviceFeeDetail: 'အထူးပကတိဝန်ဆောင်မှု ဂျစ်ဗားရှင်းကို အသုံးပြု၍ အပလီကေးရှင်း၏ လုံးဝ လုပ်ဆောင်ချက်များကို အသုံးပြုနိုင်ပါသည်။ အသေးစိတ်ကို ကြည့်ရန် "အသေးစိတ်" ကိုနှိပ်ပါ',
    packageAutoRenew: 'အလိုအလျောက် အဆင့်မြှင့်တင်ခြင်း ဂျစ်ဗားရှင်း',
    packageNonAutoRenew: 'အလိုအလျောက် အဆင့်မြှင့်တင်ခြင်းမရှိသော ဂျစ်ဗားရှင်း',
    notFoundPurchase: 'သင့်ပေးဆောင်မှုကို ရှာမတွေ့ပါ',
    purchaseLinkedWithOtherAcc: 'ဤပေးဆောင်မှုသည် အခြားအကောင့်နှင့် ချိတ်ဆက်ပြီးပါပြီ',
    recoverySumary: 'သင်သည် ပေးဆောင်မှုကို အောင်မြင်စွာ ပြီးစီးခဲ့ပါက၊ အထူးပကတိ ဂျစ်ဗားရှင်းအား မရရှိပါက "ပေးဆောင်မှုကို ပြန်လည်လက်ခံ" ကို ရွေးချယ်ပါ',
    recoverySumary1: 'မအောင်မြင်ပါက၊ အက်ပလီကေးရှင်းမှ ထွက်ပြီး ပြန်လည်ဝင်ပါ',
    purchaseProcessing:
      'ပေးဆောင်မှုသည် လက်ရှိတွင် လုပ်ဆောင်နေပါသည်၊ မတိုင်မီ အချိန်အနည်းငယ် စောင့်ဆိုင်းပါ။ ပေးဆောင်မှု အောင်မြင်ပြီးလျှင် မကြာခင် အခြေအနေများ ပြောင်းလဲမည်မဟုတ်ပါက ပေးဆောင်မှုကို ပြန်လည်လက်ခံပါ',
    iapInLoading: 'မရရှိပါ။ မတိုင်မီ စောင့်ဆိုင်းပါ',
    yourPackageInfo: 'သင့်၏ ဂျစ်ဗားရှင်းအကြောင်းအရာ',
    compare: 'အခမဲ့ - အထူးပကတိ နှိုင်းယှဉ်ခြင်း',
    trialConfirm: 'သင်သည် ၇ ရက်အတွင်း အထူးပကတိ ဂျစ်ဗားရှင်းကို အသုံးပြုမည်ဟု သေချာပါသလား။ အချိန်ကုန်ဆုံးသောအခါ ဂျစ်ဗားရှင်းကို အခမဲ့အနေဖြင့် ပြန်လည်ပြောင်းလဲမည်',
    trialActive: 'သုံးစွဲမှုကို အတည်ပြုပါ',
    trialActiveDetail:
      'သင့်မှာ အခမဲ့ ဂျစ်ဗားရှင်းကို အသုံးပြုနေပါသည်။ သင်သည် ၇ ရက်အတွင်း အထူးပကတိ ဂျစ်ဗားရှင်းကို အသုံးပြုချင်ပါသလား? အချိန်ကုန်ဆုံးပါက အခမဲ့ ဂျစ်ဗားရှင်းသို့ ပြန်လည်ပြောင်းလဲမည်!'
  },
  upgrade: {
    hasNewVersion: 'သစ်သောဗားရှင်းရှိသည်',
    changelog: 'သစ်သောဗားရှင်းတွင် ပြောင်းလဲမှုများ',
    upgradeNow: 'အပ်ဒိတ်လုပ်ပါ',
    later: 'ပြီးလျှင်',
    changeLogs: [
      'အရောင်မကောင်းသောစာသားကို အမှန်အတိုင်းပြင်ဆင်ပါ',
      'အချို့သောပလက်ဖောင်းများတွင် အော်ဒါဝယ်ယူမှု မသိမ်းဆည်းနိုင်သောအမှားကို ပြင်ဆင်ပါ',
      'အလင်း dark light အပြင်အဆင်နှင့် ကိုက်ညီသောကြော်ငြာများကို အောက်မေ့ပါ',
      'developer ကို တာဝန်ယူအပြီး မှတ်တမ်းအမှားပိုမိုသွားနိုင်ရေး',
      'နှင့် တခြားအမှားအတိများပြင်ဆင်ခြင်း'
    ]
  },
  profile: {
    title: 'ပုဂ္ဂိုလ်ရေး',
    nameShop: 'ဆိုင်အမည်',
    email: 'အီးမေးလ်',
    address: 'လိပ်စာ',
    phone: 'ဖုန်းနံပါတ်',
    numberPhone: 'ဖုန်းနံပါတ်',
    edit: 'ပြင်ဆင်',
    save: 'သိမ်းဆည်း',
    bank: 'ဘဏ်အကောင့်',
    billInfo: 'ဆိုင်အချက်အလက်',
    placholderBillInfo: 'ဤအချက်အလက်သည် လိပ်စာ (ဖုန်းနံပါတ်၊ လိပ်စာ၊ ဘဏ်…) ကို လက်မှတ်များဖြင့် ပြသပါမည်',
    placholderBank: 'ဘဏ်အကောင့်သွင်းပါ',
    placholderName: 'ဆိုင်အမည်သွင်းပါ',
    placholderEmail: 'အီးမေးလ်ပြင်ဆင်၍မရပါ',
    placholderAdress: 'လိပ်စာသွင်းပါ',
    placholderPhone: 'ဖုန်းနံပါတ်သွင်းပါ',
    avatarEmpty: 'ပုံရွေးချယ်ပါ',
    nameEmpty: 'ဆိုင်အမည်မပြည့်စုံပါ',
    emailEmpty: 'အီးမေးလ်မပြည့်စုံပါ',
    adressEmpty: 'လိပ်စာမပြည့်စုံပါ',
    phoneEmpty: 'ဖုန်းနံပါတ်မပြည့်စုံပါ',
    freeAcc: 'အခမဲ့',
    proAcc: 'အထူးပကတိ'
  },
  invoice: {
    stt: 'အမှတ်',
    titleImport: 'ပစ္စည်းဝယ်ယူမှု',
    title: 'ပစ္စည်းအရောင်း',
    titleReturn: 'ပစ္စည်းအပြန်အဆင်',
    code: 'ကုဒ်:',
    nameClient: 'ဖောက်သည်',
    order: 'ကုန်ပစ္စည်းကုဒ်',
    nameProduct: 'ကုန်ပစ္စည်းအမည်',
    number: 'အရေအတွက်',
    totalPrice: 'စုစုပေါင်းငွေ',
    price: 'စုစုပေါင်းငွေ',
    money: 'တန်ဖိုး',
    buyer: 'ဝယ်သူ',
    salesman: 'ရောင်းသူ',
    writeFull: '(လက်မှတ်၊ အမည်ပြည့်စုံ)',
    day: 'နေ့',
    month: 'လ',
    year: 'နှစ်',
    save: 'သိမ်းဆည်း',
    unit: 'ယူနစ်',
    thanks: 'ကျေးဇူးတင်ပါတယ်!',
    draft: 'ပြုစုပြီးသော အခြေခံမှတ်တမ်း'
  },
  barcode: {
    title: 'Barcode',
    message: 'ကင်မရာကို အဆိုပါဒေသကို ရိုက်ရန် ရွေ့ပါ'
  },
  help: {
    removeAds: 'ကြော်ငြာများကို ဖယ်ရှားနိုင်ပါသလား?',
    removeAdsDetail:
      'သင်သည် ဗားရှင်းအထွာမှ မြှင့်တင်မှုကို ဝယ်ယူ၍ ကြော်ငြာများကို ဖယ်ရှားနိုင်ပါသည်။ သင်သည် အက်ပ်ရဲ့ အားလုံးသော လုပ်ဆောင်ချက်များကို မြှင့်တင်မှုမဝယ်ထားလည်း အသုံးပြုနိုင်ပါသည်။',
    adsNotDisable: 'ကြော်ငြာများကို ငါအထွာ ဗားရှင်း ဝယ်ယူပြီးဖြစ်သော်လည်း မဖယ်ရှားပါ',
    adsNotDisableDetail:
      '- "Menu ကို ရှေ့ဘက် ညာဘက် အောက်ခြေ" -> "အထွာ ဗားရှင်း" -> "သတင်းအချက်အလက်ကို ပြန်လည်တင်ပြ" ကို ရွေးပါ။ အပြာရောင် သတင်းအချက်အလက် တက်ပြီးပါက သင်သည် ပြန်လည်အတည်ပြုထားပါသည်။ ကြော်ငြာများ မထွက်ပြန်ပါ။ \n- အနီရောင် သတင်းအချက်အလက် တက်သွားပါက ပြန်လည်အတည်ပြုခြင်း မအောင်မြင်ပါ။ သင်၏ ငွေပေးချေမှုကို ပြန်လည်စစ်ဆေးပါ။ သို့မဟုတ် iTunes Store အကောင့်တွင် တူညီသော ငွေပေးချေမှုအကောင့်ရှိပါသလား စစ်ဆေးပါ။ \n- သင်သည် ငွေပေးချေမှုကို အောင်မြင်ပြီးပြီ၊ ပြန်လည်အတည်ပြုဖို့ မရနိုင်ပါက ကျေးဇူးပြု၍ အီးမေးလ်ဖြင့် developer ဆီ ဆက်သွယ်ပါ။ xgitdev@gmail.com တွင် ကူညီပါလိမ့်မည်',
    recoveryData: 'သင်၏ဒေတာကို Backup သို့မဟုတ် တစ်ခုတည်းသောစက်သို့ ပေါ်ပြန်ပို့နိုင်ပါသလား?',
    recoveryDataeDetail:
      'သင်သည် အကောင့်တစ်ခုကို စာရင်းပေးပြီး Data sync လုပ်သော menu ကို ဖွင့်၍ သင်၏ ဒေတာကို အပ်ဒိတ်လုပ်နိုင်ပါသည်။ အဲဒီနောက် စက်ကို သုံးစွဲရာတွင် ဒေတာမဆုံးရှုံးပါ။ သင့်စက်မှာ ဒေတာ မရှိပါက Sync မလုပ်နိုင်ပါ။\nပြီးလျှင် စက်အသစ်တစ်ခုကို သုံးရန်၊ သင့်အကောင့်ကို သွင်းပြီး အဆင်ပြေပါလိမ့်မည်',
    recoveryDataAuto: 'ဒေတာကို အလိုအလျောက် Backup လုပ်နိုင်ပါသလား?',
    recoveryDataeAutoDetail: 'ဗားရှင်း 4.0 မှစ၍၊ သင်သည် ဒေတာကို လက်ခံမပါဘဲ အလိုအလျောက် Backup လုပ်ပါသည်'
  },
  importFromCSV: {
    textHint: 'သင်၏ CSV ဖိုင်မှ text အချက်အလက်များကို ဒီမှာထည့်ပါ',
    title: 'CSV ဖိုင်မှ အလွယ်တကူတင်ပါ',
    choiceFile: 'ဖိုင်ရွေးချယ်ပါ',
    intro: 'အောက်တွင် အမိန့်များကို ထည့်၍ အော်ဒါများကို ထုတ်ပေးပါ။ မူရင်းစမ်းသပ်မှုများနှင့် လမ်းညွှန်ချက်များကို ဖတ်ရန်',
    enterText: 'စာသား ထည့်ပါ',
    newCustomer: 'ဖောက်သည်အသစ်',
    productInvalid: 'ကုန်ပစ္စည်းမမှန်ကန်',
    productInvalidMessage: 'ကုန်ပစ္စည်းကုဒ်မမှန်ကန်ပါ။ ကျေးဇူးပြု၍ ကုန်ပစ္စည်းကို စစ်ဆေးပါ',
    check: 'စစ်ဆေးပါ',
    save: 'အော်ဒါ သိမ်းဆည်းပါ',
    emptyDataMessage: 'မည်သည့်အော်ဒါမှ မတွေ့ပါ',
    complete: 'သိမ်းဆည်းပြီးပါပြီ',
    gotIt: 'ကျွန်ုပ် သိပါပြီ',
    here: 'ဒီနေရာမှာ',
    syntaxIntro1: 'CSV ဖိုင်တင်ရန် မူရင်းအခြေခံကို ဒီမှာကြည့်ပါ',
    syntaxIntro2: 'အဲ့ဒီနောက် CSV ဖိုင်ကို Text အဖြစ်ဖွင့်ပြီး၊ ဖိုင်အကြောင်းကို ကော်ပီပြီး ထည့်ပါ',
    syntax: 'အညွှန်း',
    examp: 'ဥပမာ',
    syntaxTut: 'သင့်ရဲ့အချက်အလက်များကို အောက်ပါအတိုင်း ပုံစံထားပေးပါ။ အော်ဒါတိုင်းကို သတ်မှတ်ထားတဲ့ လိုင်းပေါင်းပါ။',
    syntaxDetail:
      'ဖုန်းနံပါတ်|ဖောက်သည်အမည်|လိပ်စာ, အပိုဆောင်း, ကုန်ပစ္စည်းကုဒ်|အရေအတွက်|လျှော့စျေး\nဖုန်းနံပါတ်|ဖောက်သည်အမည်|လိပ်စာ, အပိုဆောင်း, ကုန်ပစ္စည်းကုဒ်|အရေအတွက်|လျှော့စျေး, ကုန်ပစ္စည်းကုဒ်|အရေအတွက်|လျှော့စျေး\nဖုန်းနံပါတ်|ဖောက်သည်အမည်|လိပ်စာ, အပိုဆောင်း, ကုန်ပစ္စည်းကုဒ်|အရေအတွက်|လျှော့စျေး, ကုန်ပစ္စည်းကုဒ်|အရေအတွက်|လျှော့စျေး, ကုန်ပစ္စည်းကုဒ်|အရေအတွက်|လျှော့စျေး',
    syntaxExamp: '0123456789|NGUYEN VAN A|Ha Noi,10,SP1|5|0\n0123456789|NGUYEN VAN A|Ha Noi,10,SP1|5|0,SP2|4|0\n0123456789|NGUYEN VAN A|Ha Noi,10,SP1|5|0,SP2|4|0,SP3|4|0'
  },
  bill: {
    name: 'ဘီလ်',
    title: 'ငွေပေးချေမှုဘီလ်',
    product: 'ကုန်ပစ္စည်း',
    day: 'ရက်',
    amount: 'အရေအတွက်',
    money: 'စုစုပေါင်းငွေ',
    totalMoney: 'စုစုပေါင်းငွေ',
    thanks: 'ကျေးဇူးတင်ပါတယ်!',
    createBy: 'အကောင်းဆုံးရောင်းချမှု app ဖြင့်',
    unit: 'ယူနစ်',
    discount2: 'လျှော့ဈေး %',
    discount1: 'လျှော့ဈေးပမာဏ',
    customImage: 'ပုံစံပုံရိပ်',
    customText: 'အတိအကျပြင်ဆင်'
  },
  printer: {
    connected: 'ပရင်တာကိုအောင်မြင်စွာချိတ်ဆက်ပြီးပြီ!',
    name: 'ပရင်တာ',
    title: 'ပရင်တာချိတ်ဆက်ခြင်း',
    find: 'Bluetooth ပရင်တာကိုရှာနေပါသည်။ နည်းနည်းစောင့်ပါ',
    empty: 'ပရင်တာမရှိပါ',
    unknow: 'မသိရပါ',
    pressToConnect: 'သင်၏ပရင်တာကိုချိတ်ဆက်ရန်နှိပ်ပါ',
    notConnect: 'ကျေးဇူးပြု၍ ပရင်တာကို အဆင်ပြေသောပရင်တာဆက်သွယ်မှုကို စက်ချိန်ဆိုင်ရာတွင်ချိတ်ဆက်ပါ',
    trial: '%s ကြိမ် စမ်းသပ်ရန်ရှိပါသည်',
    trialExpired: 'သင်၏စမ်းသပ်မှုများကုန်ဆုံးပြီ။ ကျေးဇူးပြု၍ ပေါ်လွင်သောပရင်တာဗားရှင်းကို မလိုအပ်သောလုပ်ငန်းလျှောက်လွှာများသို့ကူးပြောင်းပေးပါ',
    printError: 'ပရင်တာမပြင်ဆင်သေးပါ။ အကျင့်တင်အသစ်ထပ်မံဆောင်ရွက်ရန်',
    devicesTested: 'အဖွဲ့ဝင်များအနေဖြင့် စမ်းသပ်ခဲ့သောပရင်တာများ: xPrinter 58iiH, GOOJPRT PT-210',
    choice: 'ပရင်တာရွေးချယ်ပါ',
    require: 'USB ချိတ်ဆက်နိုင်သော မိုဘိုင်းဘီလ် ပရင်တာကို အကူအညီပေးပါ။ သင်၏ကွန်ပျူတာတွင် ပရင်တာသည်ဒရိုင်ဗာတင်ထားရန်လိုသည်',
    fixOnWindow: 'Windows တွင် ချိတ်ဆက်မရသောပြဿနာကိုပြင်ဆင်ရန်',
    printerDriverType: 'ပရင်တာဒရိုင်ဗာအမျိုးအစား',
    printerDriverTypeDetail: 'သင်၏ကွန်ပျူတာတွင်သင်ဖွင့်ထားသော ပရင်တာဒရိုင်ဗာအမျိုးအစားကိုရွေးချယ်ပါ',
    printerDriverTypeList: ['ပရင်တာဒရိုင်ဗာ (ကုန်အမှတ်တံဆိပ်ပံ့ပိုးသူ)', 'Zadig Driver (aSeller မှ လမ်းညွှန်ချက်)'],
    printerSizeDetail: 'သင်၏ပရင်တာအရွယ်အစားကိုရွေးချယ်ပါ။ A4, A5, 80mm, 58mm စာရွက်အရွယ်အစားများကိုပံ့ပိုးသည်',
    choiceDriverTypeWarning: 'ကျေးဇူးပြု၍ သင်၏စက်တွင်တပ်ဆင်ထားသော ဒရိုင်ဗာအမျိုးအစားကိုရွေးချယ်ပါ'
  },
  importFromExcel: {
    ...EN.importFromExcel,
    textHint: 'Excel ဖိုင်မှ စာသားဒေတာကို ဒီနေရာတွင်ရိုက်ထည့်ပါ',
    title: 'Excel ဖိုင်မှ အလျင်စွာထည့်ခြင်း',
    choiceFile: 'ဖိုင်ကိုရွေးချယ်ပါ',
    intro: 'အောက်တွင်ပါရှိသောအကြောင်းအရာကိုရိုက်ထည့်ပြီး၊ အော်ဒါစတင်ဖို့ ဖွင့်ပါ။ ဤကိုမိတ်ဆက်ပေးပြီးလမ်းညွှန်ချက်များကို',
    introProduct: 'Excel ဖိုင်ကိုရွေးချယ်ပါပေါ်ပင်ထွက်သောကုန်ကြောင်းကိုလက်ခံမည်မဟုတ်ပါဘူး။ ဒေတာဖိုင်မှအသုံးပြုရမည့်သေချာသောဉပမာနှင့်လမ်းညွှန်မှုများကို',
    introProduct1: 'သင့်လက်တွေ့လှုပ်ရှားစွာ လက်ခံမယ်ဆိုပြီး Web version ကိုအသုံးပြုလိုက်ပါ။ သင်၏အချက်အလက်နှင့်အုပ်စုရိုက်နှင့်အကြောင်းအရာများကိုဤနောက်ပိုင်းတွင်အသိပေးပါ',
    enterText: 'စာသားရိုက်ပါ',
    newCustomer: 'အသစ်သောဖောက်သည်',
    productInvalid: 'ကုန်ပစ္စည်းမသင့်တော်ပါ',
    productInvalidMessage: 'ကုန်ပစ္စည်းကိရိယာမတိကျပါ။ ထည့်သွင်းမည့်ကုန်ပစ္စည်းကိုစစ်ဆေးပါ',
    check: 'စစ်ဆေးပါ',
    save: 'အကုန်ပစ္စည်း %s တင်ထား',
    emptyDataMessage: 'အော်ဒါမရှိပါ',
    complete: 'တင်ထားပြီးပါပြီ',
    gotIt: 'နားလည်ပါသည်',
    here: 'ဒီနေရာတွင်',
    syntaxIntro1:
      'တစ်ကြိမ်လျှင် မှတ်တမ်း ၅၀၀ အောက်သာ တင်သွင်းသင့်သည်။ ၎င်းတို့ကို တင်သွင်းရန် ဖိုင်များစွာအဖြစ် ခွဲနိုင်သည်။ ကုန်ပစ္စည်းများသည် တူညီသောအမည်၊ ကုဒ် သို့မဟုတ် SKU မပါဝင်နိုင်ပါ။ ပြောင်းလဲရန်မလိုအပ်သော မည်သည့်ကော်လံများကိုမဆို ဖျက်သင့်သည်။ နမူနာဖိုင်ကို ဤနေရာတွင် ကိုးကားနိုင်ပါသည်',
    syntaxIntro2: '၎င်းပါရှိသော Excel ဖိုင်ကိုစာသားအနေဖြင့်ဖြစ်ပြီး၊ Excel ဖိုင်ကိုကူးပြီးအသုံးပြုမှုနည်းကို',
    found: 'ကုန်ပစ္စည်း %s တွေ့ရှိပါသည်',
    demo: 'မည်သည့်ဖိုင်ဖြစ်နေသည်'
  },
  unit: {
    ...EN.unit,
    id: 'အမှတ်အသားတန်ဖိုး',
    title: 'တန်ဖိုးသုံးသပ်ခြင်း',
    choice: 'တန်ဖိုးရွေးချယ်ပါ',
    create: 'အသစ်တန်ဖိုးသုံးစွဲမှုသိမ်းပါ',
    name: 'တန်ဖိုးအမည်',
    search: 'အမှတ်တံဆိပ်နှင့်တစ်ခုက',
    exist: 'တန်ဖိုးအမည်ရှိပြီ',
    convert: 'ခွဲဝေစွမ်းအင်တန်ဖိုး',
    addConvert: 'ခွဲဝေစွမ်းအင်တန်ဖိုးကိုထပ်ပါ',
    editConvert: 'ခွဲဝေစွမ်းအင်တန်ဖိုးကိုပြင်ဆင်ပါ',
    valueConvert: 'အခွန်ဖြေ',
    invalidValueConvert: 'အဓိပ္ပာယ်ရှိသောအခွန်မပါရှိသောအချို့တန်ဖိုးပုံမှန်တန်ဖိုး',
    invalidMainUnit: 'မဟုတ်သောတပ်ဆင်လုပ်သတ်သတ်နေသောတန်ဖိုးစနစ်အချို့',
    sameMainUnit: 'မကြာခဏပြန်လည်ပြင်ပြီးတန်ဖိုးမတူ',
    deleteUnitConvert: 'တပ်ဆင်လိမ့်',
    deleteUnitConvertWarning: 'တပ်ဆင်ခြင်းကုန်ပစ္စည်းပြန်လိုက်နေတဲ့'
  },
  timeFilter: {
    today: 'ဒီနေ့',
    yesterday: 'မနေ့က',
    last7Days: 'ရက် ၇ ရက်အတွင်း',
    last30Days: 'ရက် ၃၀ ရက်အတွင်း',
    thisMonth: 'ဤလ',
    lastMonth: 'လတစ်လ',
    custom: 'စိတ်ကြိုက်',
    choiceMonth: 'လရွေးပါ',
    choiceStartDate: 'အစပါ',
    choiceEndDate: 'ကုန်ဆုံး'
  },
  autoRestoreDb: {
    title: 'ဒေတာ ပြန်လည်အသွင်ပြောင်းခြင်း',
    message:
      'ကျွန်ုပ်တို့သည် သင့်အကောင့်၏ အဆင့်မြင့်ဒေတာဗားရှင်းတစ်ခုကို ရှာဖွေတွေ့ရှိခဲ့ပါသည်။ သင်သည် အဆိုပါဒေတာနောက်ဆုံး version နှင့် လိုက်လျောညီထွေဖြစ်စေရန် စင်ကရိုနိုက်ချင်ပါသလား?'
  },
  support: {
    title: 'တိုက်ရိုက်ကူညီမှု',
    emailSupportDetail: 'သင့်အား ဆက်သွယ်လိုပါက ကျေးဇူးပြု၍ အောက်ပါ ဆက်သွယ်ရန်နည်းလမ်းများမှ တစ်ခုရွေးပါ။',
    emailSupport: 'ဖွံ့ဖြိုးသူထံ အီးမေးလ်ပို့ပါ',
    zaloSupportDetail: 'သင်သည် အရေးပေါ်ကူညီမှုလိုအပ်ပါက၊ အက်ပ်မှားယွင်းမှု သို့မဟုတ် အသုံးပြုမှုဆိုင်ရာ မေးမြန်းလိုပါက Zalo ကူညီမှုကို ရွေးချယ်ပါ',
    zaloSupport: 'Zalo အကောင့်မှ ကူညီမှု'
  },
  customerDebt: {
    ...EN.customerDebt,
    title: 'ကျွမ်းကျင်မှုပမာဏ',
    total: 'ကျွမ်းကျင်သေးသောပမာဏ',
    customerDebtStatistial: 'ဖောက်သည်အပေါ် ကျွမ်းကျင်မှုမှတ်တမ်း',
    startBalance: 'စတင်ချိန်ခွင်လျှာ',
    startningDebts: 'အစမြီ',
    closedBalance: 'လက်ကျန်ငွေပိတ်ခြင်း',
    closedDebts: 'အကြွေးများပိတ်ခြင်း',
    simple: 'အတိုဗားရှင်း'
  },
  returnOrder: {
    edit: 'အော်ဒါပြန်လည်ပြင်ဆင်ခြင်း',
    create: 'အော်ဒါပြန်လည်ထည့်ခြင်း'
  },
  maintenance: {
    title: 'ပြုပြင်ခြင်း',
    message: 'ကျွန်ုပ်တို့၏ဆာဗာသည် %s မိနစ်တိတိအတွင်းပြုပြင်ဆောင်ရွက်နေပါသည်။ ကျေးဇူးပြု၍ ပြန်လည်ဆက်သွယ်ပါ',
    timeout: 'စိတ်မကောင်းပါဘူး၊ ပြဿနာတစ်ခုဖြစ်ပွားခဲ့ပါသည်။ ကျေးဇူးပြု၍ အချိန်အနည်းငယ်နောက်ပိုင်းပြန်လည်ဆက်သွယ်ပါ။ အကယ်၍ ဆက်သွယ်မရလျှင် အကူအညီအတွက် ကျွန်ုပ်တို့နှင့် ဆက်သွယ်ပါ',
    messageTimeout:
      'ကျွန်ုပ်တို့၏ဆာဗာသည် အချိန်ချိန်ညှိမှုများကြောင့် အချိန်အနည်းငယ်ပိတ်ပင်နေပါသည်! ကျေးဇူးပြု၍ ထပ်မံလုပ်ဆောင်လိုက်ပါ! မရပါလျှင် ၁-၅ မိနစ်အကြာတွင် ပြန်လည်ကြိုးစားပါ',
    networkError: 'ကွန်ယက်ပြဿနာ',
    networkErrorDetail: 'အင်တာနက် ချိတ်ဆက်မှုပျက်ကွက်မှု။ ကျေးဇူးပြု၍ သင်၏ WIFI သို့မဟုတ် 4G အကြောင်းကို စစ်ဆေးပါ။ အကယ်၍ ဆက်သွယ်မရလျှင် ကျွန်ုပ်တို့ထံဆက်သွယ်ပါ'
  },
  financialBook: {
    title: 'ဘဏ္ဍာရေးစာရင်း',
    receipts: 'ငွေကြေးလက်ခံ',
    paymentVoucher: 'ငွေပေးချေမှုလက်မှတ်',
    debt: 'ကျွမ်းကျင်တောင်းဆို',
    createDebt: 'ကျွမ်းကျင်တောင်းဆိုဖန်တီး',
    moneyFromCustomer: 'ဖောက်သည်မှငွေပေးချေ',
    moneyForProvider: 'ပေးသွင်းသူအတွက်ငွေ',
    moneyForReturn: 'ပြန်အမ်းငွေ',
    moneyFromReturn: 'ပြန်အမ်းတောင်းခံ',
    idAutoGen: 'အလိုအလျောက်ဖန်တီးသောလက်မှတ် ID',
    cash: 'ငွေစာရင်း',
    bank: 'ဘဏ်',
    totalFund: 'စုစုပေါင်းအလွှာ',
    submitter: 'ဖန်တီးသူ',
    typeCharge1: 'အခွင့်အလမ်းမှတ်ပုံ',
    typeCharge2: 'ခရက်များ',
    receipt: 'ငွေကြေးလက်ခံ',
    vouchers: 'ငွေပေးချေမှုလက်မှတ်',
    fullName: 'အမည်လုံးစုံ',
    submitters: 'ပေးဝေသူများ',
    money: 'ငွေပမာဏ',
    textEmptyFinancial: 'သင်သည် ငွေကြေးလက်ခံ/ငွေပေးချေမှုမှတ်တမ်းမရှိပါ။',
    accountBank: 'လက်ခံဘဏ်စာရင်း',
    nameBank: 'ဘဏ်အမည်',
    accountNumber: 'အကောင့်နံပါတ်',
    accountHolder: 'အကောင့်ပိုင်ရှင်',
    receiptForOrder: 'အော်ဒါအတွက်ငွေကြေးလက်ခံ',
    paymentForOrder: 'အော်ဒါအတွက်ငွေပေးချေမှု',
    receiptFromCustomer: 'ဖောက်သည်မှငွေကြေးလက်ခံ',
    receiptAutoGenFor: 'အလိုအလျောက်ဖန်တီးသောငွေကြေးလက်ခံအော်ဒါအတွက်',
    paymentForProvider: 'ပေးသွင်းသူအတွက်ငွေပေးချေမှု',
    paymentForCustomer: 'ဖောက်သည်အတွက်ငွေပေးချေမှု',
    paymentVoucherAutoGenFor: 'အလိုအလျောက်ဖန်တီးသောငွေပေးချေမှုအော်ဒါအတွက်',
    autoFinancialCanNotEdit: 'ဤစာရင်းကိုအလိုအလျောက်ဖန်တီးထားပါသည်။ ဆက်စပ်သောအော်ဒါကိုပြင်ဆင်ပါ',
    createType: 'အသစ်ဖန်တီး',
    deleteType: 'အမျိုးအစားဖျက်ရန်',
    deleteTypeWarning: '%s အမျိုးအစားကိုဖျက်မည်မှာသင်သေချာပါသလား?',
    exportBill: 'လက်မှတ်ထုတ်ပို့',
    deleteBill: 'လက်မှတ်ဖျက်',
    deleteBillWarning: 'ဤလက်မှတ်ကိုဖျက်ရန်သင်သေချာပါသလား?',
    investment: 'ရင်းနှီးမြှုပ်နှံမှု',
    investmentDetail:
      'ရင်းနှီးမြှုပ်နှံမှုဆိုသည်မှာ စီးပွားရေးအတွင်း ကျန်ရှိသောငွေပမာဏ (ဝင်ငွေ - စရိတ်များ) ဖြစ်သည်။ \nဥပမာ- သင်ရွေးချယ်ထားသောအချိန်သည်ဤလဖြစ်ပါက ရင်းနှီးမြှုပ်နှံမှုသည် ၁ ရက်မှအစရှိသော အရောင်းငွေမှ စတင်ပေါင်းတင်ပါသည်',
    totalRevenue: 'စုစုပေါင်းဝင်ငွေ',
    totalSpending: 'စုစုပေါင်းစရိတ်',
    totalBlance: 'စုစုပေါင်းလက်ကျန်ငွေ'
  },
  sortType: {
    newest: 'အသစ်ဆုံး',
    oldest: 'အကြောင်းဆုံး',
    alphabet: 'အက္ခရာ'
  },
  guide: {
    revenue: 'စုစုပေါင်းဝင်ငွေ',
    expenditure: 'စုစုပေါင်းစရိတ်',
    title: 'သင့်အတွက်နိမိတ်ညွှန်',
    expenseReport: 'ဘဏ္ဍာရေးစာရင်း',
    product: 'အစမှာ၊ သင့်အရောင်းကုန်ပစ္စည်းများကိုထည့်ပါ။',
    customer: 'ဖောက်သည်အသစ်ထည့်ခြင်းသည် သင့်အတွက်ဖောက်သည်များအကြောင်းအရာများကိုစတင်ဖန်တီးရန်အခြေခံလှုပ်ရှားမှုဖြစ်ပါသည်',
    provider: 'သင့်ကိုပေးသွင်းသူများကိုဖန်တီးရန်လိုအပ်သည် အတွက် အသုံးပြုမှုအချက်အလက်များအားစီမံခန့်ခွဲပါ',
    order: 'အော်ဒါသည် ကုန်ပစ္စည်းထုတ်ကုန်ဖော်ပြချက်ကို ရေးထည့်သည်မှာ အလိုအလျောက်ပို့ဆောင်မှုရှိရန်အတွက်',
    category: 'အမျိုးအစားသည် သင့်အတွက်ကုန်ပစ္စည်းများ၏စုစုပေါင်းအမျိုးအစားများကိုစီမံခန့်ခွဲရာနေရာဖြစ်ပါသည်',
    complete: 'သင့်မှာအခြေခံလုပ်ဆောင်ချက်များကိုပြီးစီးထားပါပြီ။ aSeler က သင့်အတွက် ရည်ညွှန်းထားသောနောက်ထပ်အင်္ဂါရပ်များစွာရှိပါသည်၊ ဆက်လက်ရှာဖွေပါ'
  },
  productHistoryLog: {
    title: 'ဂိုဒေါင်သမိုင်း',
    sale: 'ကုန်ပစ္စည်းထုတ်ပေး',
    import: 'ကုန်ပစ္စည်းသွင်း',
    update: 'စင်တာစီစစ်',
    return: 'ကုန်ပစ္စည်းပြန်လည်ပေးအပ်',
    delete: 'အော်ဒါဖျက်',
    amount: 'ကုန်ပစ္စည်းအရေအတွက်',
    result: 'ကုန်ပစ္စည်းအရေအတွက်နောက်ဆုံးရလဒ်',
    importReturn: 'ပြန်လည်ပေးအပ်'
  },
  orderType: {
    sale: 'အရောင်း',
    return: 'ပြန်လည်ပေးအပ်',
    importReturn: 'ကုန်ပစ္စည်းပြန်လည်ပေးအပ်သွင်း',
    import: 'ကုန်ပစ္စည်းသွင်း',
    receipt: 'ငွေကြေးလက်ခံ',
    payment: 'ငွေပေးချေမှု',
    debt: 'ကျွမ်းကျင်တောင်းဆို'
  },
  newCodepush: {
    title: 'အသစ်ပြုပြင်ထိန်းသိမ်းမှုဗားရှင်း',
    des: 'အသစ်ပြုပြင်ထိန်းသိမ်းမှုဗားရှင်းတစ်ခု ထွက်ရှိပါသည်။ ပိုမိုတည်ငြိမ်စွာ အသုံးပြုရန် အခုဆက်အသစ်ပြုပြင်ချင်ပါသလား?',
    cancel: 'အပြီးသတ်ရန်',
    ok: 'ပြုပြင်သည်'
  },
  printSetting: {
    ...EN.printSetting,
    title: 'ပုံနှိပ်စက်ဆက်တင်များ',
    type: 'ပုံနှိပ်စက်အမျိုးအစား',
    connection: 'ပုံနှိပ်စက်ချိတ်ဆက်မှု',
    size: 'ပုံနှိပ်ကြောင်းအရွယ်အစား',
    qrBank: 'ဘောင်တန်းအောက်တွင် ပုံရိပ်နှင့် အစီအစဉ် ထည့်သွင်းပါ',
    qrBankDetail: 'သင်သည် ဘဏ် QR ကို ပုံစံအသစ်အနေဖြင့်ထည့်နိုင်ပြီး၊ စတိုးပွဲတင်ထားသော အမှတ်တံဆိပ်အပါအဝင် များကိုလည်းထည့်နိုင်ပါသည်',
    asellerLogo: 'aSeller လိုဂို ကိုပြသပါ',
    bluetooth: 'Bluetooth ပုံနှိပ်စက်',
    wifi: 'WiFi ပုံနှိပ်စက်',
    deviceIp: 'ပုံနှိပ်စက် IP လိပ်စာ',
    deviceIpEx: 'ဥပမာ: 192.168.1.100',
    invalidIP: 'ကျေးဇူးပြု၍ IP လိပ်စာမှန်ကန်မှုကို ထည့်သွင်းပါ!',
    canNotConnectIP: 'ဒီ IP နှင့်ချိတ်ဆက်၍မရပါ။ ပုံနှိပ်စက်၏ IP ကို ထပ်မံစစ်ဆေးပါ!',
    notReady: 'ပုံနှိပ်စက်မရှိပါ။ ပုံနှိပ်စက် ဆက်တင်များကိုစတင်ပါ!',
    support:
      'ESC/POS အပူအပေါင်းပုံနှိပ်စက်များ WiFi, Bluetooth, USB ဖြင့် ချိတ်ဆက်နိုင်ပါသည်။\nအသိပေးချက်: အဖွဲ့နှင့်ပတ်သက်သော ပုံနှိပ်စက်များပုံနှိပ်မည်မဟုတ်ပါ။\nကျေးဇူးပြု၍ "သွားလာကိရိယာများ" နေရာအတွက် ပိုမိုအသေးစိတ် သိရှိရန် ကြည့်ပါ။',
    orientation: 'ပုံနှိပ်ရိုက်ကွင်းပုံစံ',
    potrait: 'အတည်ပြုမျိုး',
    landscape: 'အတိုင်းအတာ'
  },
  homeOfflineWarning: {
    message: 'သင်သည် OFFLINE အသုံးပြုနေသည်။ ONLINE သို့ပြောင်းလဲပြီး အများပြားသော လုပ်ဆောင်ချက်များကို အသုံးပြုနိုင်ပါသည်။ အခြားစနစ်များရော ကိစ္စများ၏ဒေတာများ မပျောက်ပယ်သွားပါ။',
    helpButton: 'ONLINE သို့ပြောင်းရန် လမ်းညွှန်'
  },
  statStock: {
    typeChoice: 'ဂိုဒေါင်အစီရင်ခံ',
    inventoryCapital: 'ရင်းနှီးမြှုပ်နှံမှုရှိငွေ'
  },
  customerGroup: {
    title: 'ဖောက်သည်အဖွဲ့',
    search: 'နာမည်၊ ဒေါ်ကုတ်တံဆိပ်ကိုဖြင့် ရှာပါ',
    id: 'အဖွဲ့ ID',
    prefix: 'အဖွဲ့ကုတ်ပြိုင်နံပါတ်',
    create: 'အဖွဲ့အသစ်ထည့်ရန်',
    choice: 'ဖောက်သည်အဖွဲ့ကိုရွေးပါ',
    choiceCustomers: 'ဖောက်သည်များကို အဖွဲ့တွင် ထည့်ပါ',
    name: 'အဖွဲ့အမည်',
    tablePrice: 'ဈေးနှုန်းဇယား',
    priceHint: 'ဈေးနှုန်းဇယားကိုဖောက်သည်အဖွဲ့သို့အလိုအလျောက်အသုံးပြုနိုင်ပါသည်',
    editNotice: 'ပြင်ဆင်မှုမုဒ်တွင်ရှိသည် - ပြီးစီးရန် အပေါ်ဘက်ရှိ "သိမ်းဆည်းမည်" ကိုနှိပ်ပါ',
    removeCustomer: 'သင်သည်ဤဖောက်သည်ကိုအဖွဲ့မှဖယ်ရှားမည်မှာသင်သေချာပါသလား?'
  },
  settings: {
    title: 'ဆက်တင်များ',
    garena: 'ပုံမှန်ဆက်တင်များ',
    home: 'ပွင့်လင်းစာမျက်နှာဆက်တင်',
    order: 'အော်ဒါဆက်တင်',
    product: 'ကုန်ပစ္စည်းဆက်တင်',
    invoice: 'ဘောင်ချ်ဆက်တင်',
    debt: 'အကျိုးဆက်ပေးငွေဆက်တင်',
    point: 'မှတ်ပုံတင်ဆက်တင်',
    salesGroup: 'အရောင်းနှင့် ပြေစာများ',
    systemGroup: 'စနစ်နှင့် ပုံစံ',
    businessGroup: 'ဖောက်သည်နှင့် လုပ်ငန်း',
    accountGroup: 'အကောင့်နှင့် လုံခြုံရေး',
    displayAndTheme: 'ပြသမှုနှင့် ပုံစံ',
    currencyAndTime: 'ငွေကြေးနှင့် အချိန်',
    security: 'လုံခြုံရေး',
    stockSettings: 'ကုန်ပစ္စည်းစာရင်း ဆက်တင်များ',
    homeWidgets: 'ပင်မစာမျက်နှာ ဝစ်ဂျက်များ',
    pointSettings: 'အမှတ်များ ဆက်တင်',
    resetPointTitle: 'ဆက်တင်များကို ပြန်လည်သတ်မှတ်မည်',
    systemPermissions: 'စနစ် ခွင့်ပြုချက်များ',
    invoiceSettings: 'ပြေစာ ဆက်တင်များ',
    debtSettings: 'ကြွေးကျန် ဆက်တင်များ',
    orderSettings: 'အော်ဒါ ဆက်တင်များ',
    descOrder: 'အခြေအနေ၊ ဂဏန်းအဝိုင်း၊ အပိုကြေး၊ နာရီအလိုက် ဝန်ဆောင်မှု',
    descProduct: 'လက်ကျန်စာရင်း၊ မူရင်းစျေးနှုန်း၊ ကနဦးသိုလှောင်မှု',
    descInvoice: 'ပြေစာပုံစံ၊ VietQR၊ ဘဏ်အကောင့်',
    descPrinter: 'စက္ကူအရွယ်အစား၊ ဘလူးတုသ်၊ ဝိုင်ဖိုင်၊ USB ပရင်တာ',
    descShift: 'အဆိုင်းဖွင့်ခြင်း၊ ပိတ်ခြင်း၊ ငွေလွှဲပြောင်းခြင်း',
    descGeneral: 'ပုံစံ၊ ဘာသာစကား၊ ဖောင့်အရွယ်အစား၊ ငွေကြေး၊ PIN',
    descHome: 'ဝင်ငွေပြသမှု၊ ဇယားများ၊ ဘဏ္ဍာရေး အစီရင်ခံစာ',
    descPermission: 'ကင်မရာ၊ ဓာတ်ပုံပြခန်း၊ ဘလူးတုသ်၊ အသိပေးချက်များ',
    descPoint: 'အဖွဲ့ဝင် ရမှတ်များ၊ လဲလှယ်နှုန်း',
    descShop: 'ဘဏ်ခွဲများ၊ ဝန်ထမ်းစီမံခန့်ခွဲမှု၊ အရောင်းဝဘ်ဆိုဒ်',
    descEInvoice: 'အီလက်ထရွန်းနစ်ပြေစာ ဖွဲ့စည်းမှုနှင့် ထုတ်ပေးမှု',
    descPassword: 'အကောင့်စကားဝှက် ပြောင်းလဲရန်',
    descDeleteAcc: 'အကောင့်နှင့် ဆိုင်ဒေတာများကို အပြီးတိုင် ဖျက်ပစ်မည်',
    shopManager: 'ဆိုင်မန်နေဂျာ',
    staffRole: 'ဝန်ထမ်း',
    granted: 'ခွင့်ပြုပြီး',
    grantPermission: 'ခွင့်ပြုချက်ပေးရန်',
    noVietQRConfig: 'VietQR ဘဏ်အကောင့် မသတ်မှတ်ရသေးပါ',
    uploadQRImage: 'QR ကုဒ်ပုံ အပ်လုဒ်လုပ်ရန်',
    s2aHkdGroup: 'S2A-HKD စီးပွားရေးအုပ်စု',
    s2aHkdGroupDetail: 'S2A-HKD စာရင်း ထုတ်ယူသည့်အခါ မူရင်းလုပ်ငန်းအုပ်စု',
    s2aHkdTaxRate: 'S2A-HKD မူရင်းအခွန်နှုန်း (%)',
    s2aHkdTaxRateDetail: 'ကုန်ပစ္စည်း/အော်ဒါတွင် ရှင်းလင်းသော အခွန်မရှိပါက သုံးသည်',
    s2aHkdTncnRate: 'S2A-HKD တစ်ဦးချင်းဝင်ငွေခွန်နှုန်း (%)',
    s2aHkdTncnRateDetail: 'S2A-HKD ထုတ်ယူသည့်အခါ အသုံးပြုသည့် အခွန်နှုန်း (%)',
    manualEnterIPDetail: 'ပရင်တာကို ရှာမတွေ့ပါက IP ကို တိုက်ရိုက်ရိုက်ထည့်ပါ',
    previewPrint: 'ပုံနှိပ်အစမ်းကြည့်ရှုခြင်း'
  },
  customerPoint: {
    pointShort: 'အမှတ်',
    point: 'စုစည်းထားသောအမှတ်',
    description: 'ဖောက်သည်ဆုလာဘ်စီမံခန့်ခွဲမှု',
    history: 'အမှတ်စုစည်းမှုသမိုင်း',
    use: 'အမှတ်စနစ်ကိုအသုံးပြုပါ',
    mtpRate: 'အမှတ်ပြောင်းလဲနှုန်း',
    mtpRateDetail: 'အော်ဒါတန်ဖိုး %s%s = 1 အမှတ်စုစည်းမှု',
    ptmRate: 'ငွေပြောင်းလဲနှုန်း',
    ptmRateDetail: '1 အမှတ် = %s%s',
    allowPayment: 'အမှတ်ဖြင့်ပေးချေခွင့်ပြုပါ',
    allowForSaleProduct: 'အရောင်းကုန်ပစ္စည်းများအတွက် အမှတ်စနစ်ကိုပြုလုပ်ပါ',
    allowForOrderPayByPoint: 'အမှတ်ဖြင့်ပေးချေသောအော်ဒါများအတွက် အမှတ်စနစ်ကိုပြုလုပ်ပါ',
    change: 'အမှတ်စုစည်းမှုကိုပြောင်းလဲပါ',
    invalidPoint: 'အမှတ်မှားပါ',
    invalidNote: 'ကျေးဇူးပြု၍ မှတ်စုထည့်ပါ',
    usePoint: 'အမှတ်အသုံးပြုပါ',
    showPointOnInvoice: 'ဘောင်ချ်ပေါ်တွင် အမှတ်ပြသပါ',
    reset: 'စုစည်းထားသောအမှတ်အားလုံးကိုဖျက်သိမ်းပါ',
    resetWarning: 'သင်သည် ဖောက်သည်၏အမှတ်စုစည်းမှုအားလုံးကိုဖျက်သိမ်းမည်ကိုသေချာပါသလား?'
  },
  shift: {
    title: 'ကာလပိတ်သိမ်းမှု',
    end: 'ကာလပိတ်သိမ်းမှု',
    totalOrder: 'စုစုပေါင်းဘောင်ချ်',
    totalMoney: 'စုစုပေါင်းကာလငွေ',
    paid: 'ပေးအပ်သောငွေ',
    staff: 'ဝန်ထမ်း',
    cash: 'ငွေသား',
    bank: 'ဘဏ်လွှဲပြောင်း',
    emptyOrder: 'ယခုအလုပ်ချိန်တွင် အော်ဒါမရှိသေးပါ။',
    shiftOrder: 'ကာလအော်ဒါ',
    open: 'အလုပ်ချိန်ဖွင့်ရန်',
    closed: 'အလုပ်ချိန်ပိတ်သိမ်းမှု',
    opening: 'အလုပ်ချိန်ဖွင့်ရန်',
    openingAmount: 'စတင်ငွေ',
    handoverType: 'လွှဲပြောင်းနည်းလမ်း',
    actualHandoverAmount: 'အမှန်တကယ်လွှဲပြောင်းငွေ',
    differenceAmount: 'ကွာခြားချက်',
    totalExpectedHandoverAmount: 'လွှဲပြောင်းရန် လိုအပ်သော စုစုပေါင်းငွေ',
    orderUnit: 'အော်ဒါ',
    currencyUnit: '₫',
    endReport: 'အလုပ်ချိန်ပိတ်သိမ်းမှုအစီရင်ခံစာ',
    ended: 'အလုပ်ချိန်ပိတ်သိမ်းပြီး',
    shift: 'အရောင်းအဆိုင်း',
    actualHandoverDesc: 'ဝန်ထမ်းမှ လက်တွေ့လွှဲပြောင်းပေးသော ငွေပမာဏ',
    updatingOnClose: 'အဆိုင်းပိတ်ချိန်တွင် အပ်ဒိတ်လုပ်မည်',
    matchedDiffDesc: 'ငွေပမာဏ အတိအကျ ကိုက်ညီပါသည်',
    checkDiffDesc: 'ကွာခြားမှု အကြောင်းရင်းကို စစ်ဆေးရန် လိုအပ်သည်',
    diffCalculatedOnClose: 'အဆိုင်းလွှဲပြောင်းပြီးနောက် တွက်ချက်သည်',
    searchOrdersPlaceholder: 'အော်ဒါနံပါတ်၊ ဝယ်သူ၊ ဖုန်းဖြင့် ရှာရန်...',
    handoverTypeDetail: 'ဝန်ထမ်းများ ဂျူတီပိတ်ပြီး လွှဲပြောင်းချိန်တွင် လက်ခံရရှိသော ငွေပေးချေမှုပုံစံ',
    requireOpening: 'အလုပ်ချိန်ဖွင့်ရန်လိုအပ်သည်',
    requireOpeningDetail: 'အလုပ်ချိန်ဖွင့်ထားမှသာ အရောင်းအော်ဒါဖန်တီးနိုင်သည်',
    settings: 'အလုပ်ချိန်ဆက်တင်',
    settingsDetail: 'အလုပ်ချိန်ဖွင့်ခြင်းနှင့် လွှဲပြောင်းခြင်းကို စီစဉ်ပါ',
    openError: 'အလုပ်ချိန်ဖွင့်မရပါ',
    expectedHandoverAmount: 'လွှဲပြောင်းရန်မျှော်မှန်းငွေ',
    totalMoneyInShift: 'ကာလအတွင်း စုစုပေါင်းငွေ',
    needHandover: 'လွှဲပြောင်းရန် လိုအပ်သည်',
    endConfirm: 'ဤအလှည့်ကို ပိတ်ရန် သေချာပါသလား?'
  },
  warehouse: {
    title: 'ကုန်ပစ္စည်းစျေးကွက် (အဖွဲ့ခွဲ)',
    renew: 'ဂိုဒေါင် သက်တမ်းတိုးရန်',
    choice: 'ကုန်ပစ္စည်းစျေးကွက်ရွေးချယ်ပါ',
    intro:
      'အမျိုးမျိုးသောစျေးကွက်များတွင် ရှိနေသောကုန်ပစ္စည်း၊ အရောင်းနှင့် ဘဏ္ဍာရေးနှုန်းများကွာခြားနေပါသည်။ "ကုန်ပစ္စည်းစျေးကွက်စီမံခန့်ခွဲမှု" အတွင်းသို့ဝင်ပြီး စျေးကွက်အသစ်များဖန်တီးပါ။',
    stat: 'စျေးကွက်အခြေအနေ',
    createNew: 'စာရွက်တင်သွင်းခြင်းဖန်တီးပါ',
    create: 'ကုန်ပစ္စည်းစျေးကွက်တည်ဆောက်ပါ',
    checkId: 'စစ်ဆေးကုဒ်',
    name: 'ကုန်ပစ္စည်းစျေးကွက်အမည်',
    check: 'ကုန်ပစ္စည်းစစ်ဆေးမှု',
    createCheck: 'ကုန်ပစ္စည်းစစ်ဆေးစာရွက်ဖန်တီးပါ',
    history: 'ကုန်ပစ္စည်းစစ်ဆေးမှုသမိုင်း',
    noHistory: 'ကုန်ပစ္စည်းစစ်ဆေးမှုသမိုင်းမရှိပါ။ ကျေးဇူးပြု၍ အသစ်သောစာရွက်တင်ပါ',
    noTransferHistory: 'ကုန်ပစ္စည်းပြောင်းရွှေ့မှုသမိုင်းမရှိပါ!',
    totalProduct: 'စုစုပေါင်းကုန်ပစ္စည်း',
    tmpCheck: 'အချိန်ပိုင်းစစ်ဆေးစာရွက်',
    cancelCheckConfirm: 'သင်သည် ဤစစ်ဆေးစာရွက်ကိုဖျက်သိမ်းမည်မှာသေချာပါသလား?',
    cancelTransferConfirm: 'သင်သည် ဤကုန်ပစ္စည်းပြောင်းရွှေ့စာရွက်ကိုဖျက်သိမ်းမည်မှာသေချာပါသလား?',
    default: 'မူလကုန်ပစ္စည်းစျေးကွက်',
    address: 'ကုန်ပစ္စည်းစျေးကွက်လိပ်စာ',
    manager: 'ကုန်ပစ္စည်းစျေးကွက်စီမံခန့်ခွဲသူ (အဖွဲ့ခွဲ)',
    detail: 'ကုန်ပစ္စည်းစျေးကွက်အသေးစိတ်',
    transfer: 'ကုန်ပစ္စည်းပြောင်းရွှေ့မှု',
    transferCard: 'ကုန်ပစ္စည်းပြောင်းရွှေ့မှုအသေးစိတ်',
    checkCard: 'ကုန်ပစ္စည်းစစ်ဆေးမှုအသေးစိတ်',
    exportCheckCard: 'ကုန်ပစ္စည်းစစ်ဆေးစာရွက်',
    exportTransferCard: 'ကုန်ပစ္စည်းပြောင်းရွှေ့စာရွက်',
    emptyTargetWarehouse: 'ပြောင်းရွှေ့ရာစျေးကွက်မမှန်ကန်ပါ။ ကျေးဇူးပြု၍ ရွေးချယ်ပါ!',
    limit: 'သတိပြုရန်: အကောင့်တစ်ခုလျှင် ဒုတိယစျေးကွက်အတွက် ၁လအထိ အခမဲ့ဖြစ်ပါသည်။ အချိန်ကုန်ဆုံးရင် အသုံးပြုရန် ကြာမြင့်တောင်းဆုသင့်ပါသည်',
    expired: 'ဤကုန်ပစ္စည်းစျေးကွက်သည် ကြာမြင့်ပြီးပြီ။ အသုံးပြုရန် ကာလအတိုးလိုအပ်ပါသည်!',
    package1Y: '၁နှစ်အတိုးချုပ်',
    importFromExcelHint: 'Excel ဖိုင်မှ ကုန်ပစ္စည်းများကို အရှိန်မြှင့်၍ ထည့်သွင်းပါ။',
    importFromExcelEmptyChange: 'ပြောင်းလဲမှုမရှိပါ။',
    emptyTransferHint: 'ဂိုဒေါင်ပြောင်းရွှေ့ရန် "ဘားကုဒ်" သို့မဟုတ် "ကုန်ပစ္စည်း" ကို နှိပ်ပါ',
    emptyCheckHint: 'စတော့စစ်ဆေးရန် "ဘားကုဒ်" သို့မဟုတ် "ကုန်ပစ္စည်း" ကို နှိပ်ပါ',
    noProduct: 'ကုန်ပစ္စည်း မရွေးချယ်ရသေးပါ'
  },
  homeScreen: {
    support: 'သင်အကူအညီလိုပါသလား?',
    supportDetail: 'သင်၏မေးခွန်းများကို ဖြေကြားခြင်း သို့မဟုတ် ပြဿနာများကို အစီရင်ခံရန် ကျွန်ုပ်တို့အား အကြောင်းပြန်ပါ',
    changelog: 'ပြောင်းလဲမှုများစာရင်း',
    changelogDetail: 'ပြောင်းလဲမှုများစာရင်း ကို အခြားအသစ်များနှင့် တပြိုင်နက် လိုက်နာပါ',
    autoUpdate: 'အလိုအလျောက် အဆင့်မြှင့်ခြင်း',
    autoUpdateDetail: 'စနစ်သည် အခြားအနည်းငယ်သော အမှားများကို ပြန်လည်ပြင်ဆင်ရန် ဤနည်းလမ်းကိုအသုံးပြုမည်ဖြစ်ပြီး မကြာခင်တွင် အသစ်သောဗားရှင်းကို တပ်ဆင်ရန် လိုအပ်ပါသည်',
    autoUpdateNoAvailable: 'သင်သည် အသစ်ဆုံးဗားရှင်းကို အသုံးပြုနေပါပြီ!',
    autoUpdateFailed: 'အဆင့်မြှင့်ခြင်းအတွင်း မှားယွင်းမှုတစ်ခုခု ဖြစ်ပါသည်။ ပြန်လည်ကြိုးစားပါ!',
    vipExpired: 'သင်၏ VIP အကောင့်သည် ကြာမြင့်ပြီးပြီ။ အပြည့်အစုံအသုံးပြုရန် အတိုးသက်တမ်းလိုအပ်ပါသည်!'
  },
  productSetting: {
    sort: 'စာရင်းစီမံခြင်း',
    sortDetail: 'ကုန်ပစ္စည်းများကို အောက်ပါအတိုင်း စီစဉ်ပါ',
    sortTypes: ['သစ်ဆုံးဖြစ်သော အစ', 'အက္ခရာအလိုက်အမည်', 'အဟောင်းဆုံးဖြစ်သော အစ', 'အသုံးပြုမည့်နေ့']
  },
  intro: {
    shift:
      'ဤလုပ်ဆောင်ချက်သည် ဝန်ဆောင်မှုစီးပွားရေးအတွက် သတ်မှတ်ထားပါသည်။ ဝန်ထမ်းများသည် ဝန်ထမ်းအက်ပ်ကို အသုံးပြု၍ ကာလသွားအဆုံးသတ် ပြုလုပ်ပါသည်။ ဝန်ထမ်း၏ ကာလသွားအဆုံးသတ်အချက်အလက်များကို ဤနေရာတွင် ပြသပါမည်။',
    customerGroup:
      'ဤလုပ်ဆောင်ချက်သည် ဖောက်သည်အုပ်စုများကို စုစည်းရန် အသုံးပြုသည်။ ဥပမာ - အဆင့် ၁၊ အဆင့် ၂ ဂျွန်များ၊ သင့်သည် ကုန်ပစ္စည်းအတွက် တစ်ခုချင်းစီသော စျေးနှုန်းစာရင်းကို ဖန်တီးနိုင်ပါသည်။ သင်သည် ငွေတောင်းခံမှုကို ဖန်တီးရာတွင် ဤအုပ်စုအပေါ်မှ ဖောက်သည်များသည် ထုတ်ကုန်အတွက် သင့်စာရင်းကို အလိုအလျောက်အသုံးပြုပါမည်။',
    emptyProduct: 'ထုတ်ကုန်များ မရှိပါ။ ထပ်မံထည့်ရန် ကျေးဇူးပြု၍ ကုန်ပစ္စည်းများထည့်ပါ!',
    draftOrder: 'ဤလုပ်ဆောင်ချက်သည် သင့်အား အင်တာနက်ချိတ်ဆက်မှုမရှိသော်လည်း တစ်ချိန်တည်းတွင် ပစ္စည်းပေါင်းများစွာကို မှတ်ပုံတင်နိုင်သည်။ ဤကိစ္စသည် သင့်အတွက် အကျိုးရှိနိုင်ပါသည်။'
  },
  printBarcode: {
    print: 'တံဆိပ်ပုံနှိပ်ရန်',
    list: 'တံဆိပ်စာရင်း',
    config: 'တံဆိပ်ပုံနှိပ်ခြင်းပြင်ဆင်မှု',
    size: 'တံဆိပ်အရွယ်အစား (ရှည် \u00d7 ကျယ်) (မီလီမီတာ)',
    note: 'မှတ်စု',
    column: 'တံဆိပ်ပုံနှိပ်ပုံစံ အတန်းအမြင့်',
    paddingH: 'တံဆိပ် ၂ ခုအကြား များသောကြားအကွာအဝေး (မီလီမီတာ)',
    paddingV: 'တံဆိပ် ၂ ခုအကြား လိုက်လျောညီထွေ ရှု့ကိုရြှမ်းအကွာအဝေး (မီလီမီတာ)',
    noteDetail: 'ဗားချင်ကို စနစ်တကျ မရိုက်နိုင်လျှင်၊ သို့မဟုတ် နောက်ထပ်တံဆိပ်တစ်ခုတိုးချဲ့ပေးရပါမည်',
    dpi: 'ပုံနှိပ်စက် DPI',
    multiUpdateQuantity: 'ပစ္စည်းအရေအတွက်များကို တစ်ပြိုင်နက်တည်း ပြင်ဆင်ပါ',
    invalidQuantity: 'အရေအတွက် မမှန်ကန်ပါ!',
    barcodeWidth: 'ဘားကုဒ်ရဲ့ အကျယ်',
    autoPrintWhenInBill: 'ဘီလ်တွင် လိုအပ်သော အချိန်တိုင်း သင့်ကိုယ်ပိုင်ဘားကုဒ်ပုံနှိပ်ရန်',
    autoPrintWhenInBillDetail: 'ဘီလ်နှင့် နောက်ဆုံးပိုင်းတွင် အလိုအလျောက် ပုံနှိပ်မည်',
    printerNotRealdy: 'ဘားကုဒ်ပုံနှိပ်စက် မရရှိပါ။ ဤနေရာကို ပြင်ဆင်ပါ',
    contentToDisplay: 'အညွှန်းပေါ်တွင်ပြသရန်အကြောင်းအရာ',
    parameters: 'ဘောင်များ',
    lengthXWidth: 'အရှည် × အကျယ် (mm)',
    sampleProduct: 'နမူနာထုတ်ကုန်'
  },
  draftOrder: {
    title: 'သရုပ်ပြမည့် အမိန့်',
    manager: 'သရုပ်ပြအမိန့်များကို စီမံခန့်ခွဲပါ',
    cancel: 'သရုပ်ပြခြင်းကို အမှတ်တရ ရပ်ဆိုင်းပါ',
    cancelConfirm: 'သင်ကဒီ အမိန့်ကို ဖျက်ပစ်ချင်ပါသလား?',
    noConnectionWarning: 'သင်၏ device မရှိသေးပါ၊ အင်တာနက်ချိတ်ဆက်မှုရှိနိုင်အောင် မြောက်သောအတိုင်း အသုံးပြု၍ ချိတ်ဆက်ပါ။',
    emergencyModeWarning: 'You are in emergency mode. Orders are only saved temporarily on your device and have not been recorded to the server.',
    exportInvoice: 'ဖြန့်ချိထားသော ငွေတောင်းခံလွှာ'
  },
  deleteAcc: {
    title: 'အကောင့် ဖျက်ခြင်း',
    warning: 'သင်သေချာပြီလား။ ပြီးသောပွဲတွင် အမှတ်တရ ဖျက်သိမ်းလိမ့်မည်။',
    confirmCode: 'အတည်ပြုကုဒ်',
    confirmCodeShort: 'အတည်ပြုကုဒ်သည် မထောက်ခံနိုင်ပါ။'
  },
  debtNotify: {
    ...EN.debtNotify,
    title: 'အကြွေးကို ဆပ်ရန်',
    money: 'ဆပ်ရန်ငွေပမာဏ: '
  },
  restartApp: {
    title: 'အက်ပ်ကို ထပ်မံစတင်မည်',
    detail: 'အပြောင်းအလဲများအတွက် အက်ပ်ကို ထပ်မံစတင်ချင်ပါသလား?'
  },
  appError: {
    eyebrow: 'ပြဿနာတစ်ခု ဖြစ်ပွားခဲ့သည်',
    title: 'အက်ပ်ကို ပြန်လည်စတင်ရန် လိုအပ်သည်',
    detail: 'မမျှော်လင့်ထားသော အမှားတစ်ခု ဖြစ်ပွားခဲ့သည်။ ဆက်လုပ်ရန် အက်ပ်ကို ပြန်လည်စတင်ပါ။',
    reload: 'အက်ပ်ကို ပြန်လည်စတင်ပါ'
  },
  shopSetting: {
    link: 'အများပြည်သူဆိုင်ရာလင့်ခ်',
    publicSetting: 'အများပြည်သူဆိုင်ရာပြင်ဆင်မှု',
    publicSettingHint: 'ဖောက်သည်များသည် အများပြည်သူလင့်ခ်မှတစ်ဆင့် အားလုံးအားလုံးကို မှာယူနိုင်ပါသည်။',
    userName: 'ဆိုင်အမည်',
    userNameHint: 'ဤအမည်သည် ဖောက်သည်များအားပေးပို့သောလင့်ခ်တွင် ပြသမည်။ အကွာအဝေး သို့မဟုတ် အထူးသင်္ကေတများ မပါရှိရပါ။ (ဂဏန်း၊ ဂဏန်းအခြား၊ အင်တာနက်ကန့်သတ်ခြင်း)',
    staffRefLink: 'ဝန်ထမ်းရေးပြုတဲ့ လင့်ခ်',
    staffRefLinkHint: 'ဝန်ထမ်းဆိုင်၏ အားလုံးနောက်ပြန်ဆုံးပေးအေမှာ ကြိုတင်ကြော်ငြာရန်'
  },
  promotion: {
    edit: 'ကွှန့်ချန့်ပြုစုခြင်း',
    create: 'ကွှန့်ချန့်ပြုစုပါ',
    choice: 'ကွှန့်ချန့်ရွေးချယ်ပါ',
    title: 'အမီတာ',
    manage: 'ကွှန့်ချန့်စီမံခန့်ခွဲရန်',
    detail: 'ကွှန့်ချန့်အချက်အလက်',
    name: 'ကွှန့်ချန့်အမည်',
    code: 'ကွှန့်ချန့်ကုဒ်',
    type: 'ကွှန့်ချန့်အမျိုးအစား',
    info: 'ကွှန့်ချန့်အကြောင်းအရာ',
    order: 'အမှာစာဆွဲမှု',
    product: 'ကုန်ပစ္စည်းလျော့ပါ',
    orderGift: 'အမှာစာလက်ဆောင်',
    productGift: 'ကုန်ပစ္စည်းဝယ်ပြီးလက်ဆောင်',
    minMoney: 'အနိမ့်ဆုံးငွေပမာဏ',
    minQuantity: 'အနိမ့်ဆုံးအရေအတွက်',
    value: 'ကွှန့်ချန့်တန်ဖိုး',
    price: 'ဈေးနှုန်း',
    discountPercent: 'ဆင်းရဲချုပ်ခြင်း %',
    time: 'ကွှန့်ချန့်အချိန်',
    choiceGift: 'လက်ဆောင်ရွေးချယ်ပါ',
    gift: 'လက်ဆောင်',
    originalPrice: 'မူရင်းဈေးနှုန်း',
    delete: 'ကွှန့်ချန့်ကို ဖျက်ရန်',
    deleteConfirm: 'သင်က ကွှန့်ချန့်ကို ဖျက်ချင်ပါသလား?'
  },
  invalidField: {
    name: 'ခွင့်ပြုချက်ရှိသောအမည်ဖြည့်စွက်ပါ!',
    timeFrom: 'တင်ထားသောအချိန်အနေဖြင့် ခွင့်ပြုပါ',
    timeTo: 'အချိန်တွင်ပြောင်းလဲသည်!'
  },
  serviceSale: {
    branch: 'ရုံးခွဲ',
    found: 'ပစ္စည်းများ မတွေ့ပါ',
    clickDownload: 'ဒေါင်းလုပ်လိပ်စာကူးပါ',
    use: 'အသုံးပြုပါ',
    empty: 'အရာများ မရှိပါ',
    table: 'စားပွဲ',
    emptyTable: 'စားပွဲများ မရှိပါ',
    createBranchWarning: 'သင်သည် aSeller app ဖြင့် ရုံးခွဲအသစ်ထည့်နိုင်ပါသည်',
    addProduct: 'ထည့်မည်',
    addProduct1: 'ထည့်ဆက်ပါ',
    scanBarcode: 'ကုဒ်ပြည့်ဆွဲမှု',
    changeTable: 'စားပွဲ ပြောင်းလဲရန်',
    orderNotCreate: 'အမှာစာမတည်ဆောက်ထားသေးပါ',
    changeTableInput: 'စားပွဲ နံပါတ် ထည့်ပါ',
    error: 'အမှား',
    finish: 'ပြီးပြီ',
    selected: 'ရွေးချယ်ပြီး',
    choiceProduct: 'ထုတ်ကုန်ရွေးပါ',
    choiceProduct1: 'ပစ္စည်းရွေးပါ',
    addNewProduct1: 'အသစ်သောပစ္စည်းထည့်ပါ',
    addNewProduct: 'အသစ်ထည့်ပါ',
    selectTable: 'ဆက်သွယ်ရန်စားပွဲကိုရွေးပါ'
  },
  payment: {
    payment: 'ငွေပေးချေမှု',
    cash: 'ငွေချင်း',
    transfer: 'ငွေလွှဲ',
    totalMoney: 'စုစုပေါင်းငွေ',
    addOrder: 'ခွဲထားသောအမှာစာထည့်ပါ',
    order: 'အမှာစာဖန်တီး',
    number: 'အရေအတွက်',
    total: 'စုစုပေါင်း',
    part: 'အပိုင်း',
    client: 'ဖောက်သည်',
    customRetail: 'လက်ခံသူဖောက်သည်',
    detailPayment: 'ငွေပေးချေမှုအချက်အလက်',
    detailClient: 'ဖောက်သည်အချက်အလက်',
    nameUser: 'ဖောက်သည်အမည်',
    newCustomer: 'အသစ်သောဖောက်သည်',
    phone: 'ဖုန်းနံပါတ်',
    email: 'အီးမေးလ်',
    address: 'လိပ်စာ',
    free: 'အခမဲ့',
    note: 'မှတ်ချက်',
    updateOrder: 'အမှာစာပြင်ဆင်ရန်',
    discount: 'လျော့ပေါ့ခြင်း',
    surcharge: 'ဆပ်စစ်',
    goodsMoney: 'ပစ္စည်းတန်ဖိုး:',
    totalAmount: 'စုစုပေါင်းငွေပေးချေမှု:',
    notePayment: 'အတည်ပြုသည့်အချိန်တွင် မပြင်ဆင်နိုင်ပါ'
  },
  button: {
    yes: 'ဟုတ်',
    no: 'မဟုတ်',
    ok: 'အိုကေ',
    cancel: 'ဖျက်လိုက်ပါ',
    save: 'သိမ်းဆည်းပါ',
    delete: 'ဖျက်ပါ',
    edit: 'ပြင်ဆင်ပါ',
    edit2: 'အမည်ပြောင်းပါ',
    login: 'ဝင်မည်',
    logout: 'ထွက်မည်',
    success: 'အောင်မြင်',
    finish: 'ပြီးဆုံး',
    confirm: 'အတည်ပြုပါ',
    addNewProduct: 'အသစ်ထည့်ပါ'
  },
  alert: {
    ...EN.alert,
    orderNotCreate: 'အမှာစာမဖန်တီးထားသေးပါ သို့မဟုတ် ထည့်ရန်ပစ္စည်းမရှိပါ',
    enterFullData: 'ကျေးဇူးပြု၍ အစရှိသောအချက်အလက်များကို ဖြည့်စွက်ပါ',
    error: 'အမှား',
    emptyBranch: 'ဧည့်သည်မရှိပါ. အခွင့်အလမ်းများကိုဖော်ပြပါ',
    messager: 'သတိပေးချက်',
    openingDay: 'မနေ့တစ်နေ့ထက်ကန့်သတ်ထားသည့်အချိန်တွင် မပြင်ဆင်နိုင်ပါ',
    delete: 'သင်ဒီလိုပြင်ဆင်ခြင်းကိုဖျက်မည်လား',
    emptyInput: 'အကောင့်နံပါတ် သို့မဟုတ် မေးခွန်းများ အမှားရှိပါ',
    success: 'အောင်မြင်သောဖြေရှင်းမှု',
    textEmpty: (value) => {
      return `အချက်အလက် ${value} မရှိပါ`;
    },
    department: 'ကျေးဇူးပြု၍ ကိုယ်တိုင်လုပ်သည့်ဖိုင်ကိုထည့်ပါ',
    score: 'အမှတ်အရေအတွက်ကြီးကြီးမားမားရလွယ်ကူသည်',
    logout: 'သင်ကအချက်အလက်မှ ပယ်ချမလား',
    expiredLessThan7Day: 'သင်၏အကောင့် မပြီးဆုံးသေးပါ. နောက် 7ရက်အတွင်း သွားသည့်အချိန်ရှိပါ',
    expiredGreaterThan7Day: 'သင်၏အကောင့်မှ အဆောင့်မဖွတ်သောအချက်များ',
    userNameHasSpace: 'အမည်မှာ space ထည့်၍မရ',
    userNameIsShort: 'အမည်ပေါင်းကို 5 ကိန်းထက်ကြီးစွာသော',
    passwordIsShort: 'အနည်းဆုံး 5 ကိန်းထက်လျှော့ပါ',
    emailInvalid: 'အီးမေးလ်မှားယွင်းပါ'
  },
  composition: {
    create: 'အစိတ်အပိုင်းအသစ်ထည့်ပါ',
    title: 'အစိတ်အပိုင်း',
    name: 'အစိတ်အပိုင်းအမည်',
    intro: 'အစိတ်အပိုင်းသည် ပစ္စည်းတစ်ခု၏အစိတ်အပိုင်းတစ်ခုဖြစ်သည်။ တစ်ခုသောပစ္စည်းမှာ အစိတ်အပိုင်းများစွာပါရှိနိုင်သည်။ သင်သည် ပစ္စည်းတွင် အသေးစိတ်ဆက်သွယ်ထား၍ ထည့်သွင်းပါ',
    search: 'အစိတ်အပိုင်းရှာပါ'
  },
  bussinessType: {
    title: 'လုပ်ငန်းအမျိုးအစား',
    detail: 'သင်၏စီးပွားရေးကို လိုက်သောလုပ်ငန်းအမျိုးအစားရွေးချယ်ပါ',
    type_0: 'လက်လီ',
    type_1: 'ဆိုင်များ, စူပါမားကတ်',
    type_2: 'ကဖေ, ဆီယိုဆား',
    type_3: 'ဖက်ရှင်',
    type_4: 'အလှကုန်',
    type_5: 'မိခင် & ကလေး',
    type_6: 'မုန့်လုံးတစ်လုံး',
    type_7: 'စားသောက်ဆိုင်',
    type_8: 'ကာရိုးအိုက်, ဘီဒါ',
    type_9: 'ဆေးဆိုင်',
    type_10: 'ကစားနည်း'
  },
  hourlyService: {
    name: 'နာမည် (နာရီအချိန်ပေါ်တွင်တွက်ခြင်း)',
    nameHint: 'နာရီအချိန်ပေါ်တွင်တွက်ခြင်းသောအရာသည် ငွေကြေးခွဲခြင်း၌ ပေါ်လာပါလိမ့်မည်',
    defaultName: 'အသုံးပြုသည့်အချိန်',
    title: 'နာရီအလိုက်ပေါက်ငွေပေးချေမှု',
    detail: 'ဝန်ဆောင်မှုအသုံးပြုသည့်အချိန်အလိုက်ပေါက်ငွေတွက်ခြင်း။ \nလက်ဘက်စီးရီးပေါ်တွင်သာလျှင် အထောက်အပံ့ရှိပါသည်၊ ဝန်ဆောင်မှု',
    tablePrice: 'နာရီအလိုက်တွက်ခြင်း၏စျေးနှုန်းပြား',
    errorData: 'ဒေတာမပြည့်စုံပါ။ အနည်းဆုံးပစ္စည်းတစ်ခုကိုထည့်သွင်းပါ',
    stopTime: 'တွန်းရပ်ပါ',
    stopTimeWarning: 'သင်အချိန်နှုန်းကိုရပ်တန့်ပြီး ပေးချေမှုလုပ်ငန်းစဉ်ကိုဆောင်ရွက်လိုပါသလား?'
  },
  extraTopping: {
    errorSeparateProductNonTopping: 'Topping မပါသောထုတ်ကုန်ကိုခွဲလို့မရပါ',
    list: 'Topping စာရင်း',
    isTopping: 'ထုတ်ကုန်တစ်ခုဖြစ်သည်',
    detail:
      'ထုတ်ကုန်တစ်ခုတစ်ခုတွင်အပိုဆောင်းပစ္စည်းများပါဝင်သည်။ (ဥပမာ၊ ဆီဖတ်ခြင်းသည် ထုတ်ကုန်အတွက် topping ဖြစ်ပါသည်။) \nဤထုတ်ကုန်ကိုတိုက်ရိုက်အော်ဒါတွင်ထည့်ပါမည်မဟုတ်ပါဘူး။ \nextra topping ထုတ်ကုန်များသည် စတော့ရှယ်ယာတွင်လည်းဆောင်ရွက်မည်မဟုတ်ပါ'
  },
  comboVoucher: {
    voucher: 'Voucher ကုဒ်',
    activeVoucher: 'Voucher ကုဒ်ကိုပါဝါပေးရန်',
    activeVoucherDetail: 'Voucher ကုဒ်တစ်ခုရှိပါသလား? ဤနေရာတွင်ကုဒ်ကိုပါဝါပေးပါ',
    emptyKey: 'ကျေးဇူးပြု၍ Voucher ကုဒ်ကိုထည့်ပါ',
    choiceData: 'သင်ပါဝါပေးလိုသောဝန်ဆောင်မှုကိုရွေးချယ်ပါ၊ အပြီးသတ်ရန်ပါဝါပေးရန် နှိပ်ပါ',
    invalidKey: 'Voucher ကုဒ်မမှန်ပါ',
    activeVoucherConfirm: 'သင်ဤVoucher ကုဒ်ကိုပါဝါပေးလိုပါသလား? ဤလုပ်ဆောင်မှုသည်မပြောင်းလဲနိုင်ပါ။ ကျေးဇူးပြု၍အတည်ပြုမပေးမီစစ်ဆေးပါ',
    activeSuccess: 'Voucher ကုဒ်ကိုပါဝါပေးခြင်းအောင်မြင်ပါသည်။ စာမျက်နှာအသစ်ကိုဖွင့်ပြီးသင့်သုံးခြင်းအတွက် ထိရောက်ပါ'
  },
  protection: {
    active: 'လုံခြုံရေးကိုပါဝါပေးပါ',
    detail: 'အသုံးမပြုချိန်တွင်လျင်မြန်စွာ PIN ကုဒ်ဖြင့်အက်ပလီကေးရှင်းကိုလုံခြုံစွာပိတ်ပါ',
    enterPass: 'မိမိအကောင့်အတွက် password ထည့်ရန်လိုအပ်ပါသည်',
    pin: 'PIN ကုဒ်',
    pinRequire: 'PIN ကုဒ်သည် ၄ လုံးရှိရပါမည်',
    wrongPass: 'မှားသော password',
    forgotPin: 'PIN ကုဒ်မေ့သွားပါသလား?',
    forgotPinDetail: 'PIN ကုဒ်ပြန်သတ်မှတ်ရန်အတွက် သင်၏အကောင့် password ကိုထည့်ရပါမည်။ သင်ဤလုပ်ဆောင်မှုကိုဆောင်ရွက်လိုပါသလား?'
  },
  introData: [
    {
      title: 'aSeller POS သို့ကြိုဆိုပါသည်!',
      detail: 'သင့်၏စတိုးဆိုင်ကို မည်သည့်အချိန်တွင်မဆို ထိန်းချုပ်နိုင်စေရန် တိုးတက်သော အရောင်းစီမံခန့်ခွဲမှုဖြေရှင်းနည်း။'
    },
    {
      title: 'အော်ဒါများ၊ ထုတ်ကုန်များနှင့် ဖောက်သည်များကို လွယ်ကူစွာစီမံခန့်ခွဲပါ',
      detail: 'ဝင်ငွေ၊ သုံးစွဲမှု၊ အကြွေး၊ ပစ္စည်းသွင်းထုတ်နှင့် ငွေတောင်းခံဘောက်ချာများကို လွယ်ကူသောအဆင့်အတန်းဖြင့် ထိန်းချုပ်ပါ။'
    },
    {
      title: 'သင့်ဒေတာကို cloud ပလက်ဖောင်းတွင် သိုလှောင်ထားပြီး၊ စက်များအနက် သယ်ယူရလွယ်ကူသည်။',
      detail: '📶 မည်သည့်အချိန်တွင်မဆို ဝင်ရောက်နိုင်ပြီး၊ စက်ပြောင်းလဲလျှင်တောင် ဒေတာဆုံးရှုံးမှုမဖြစ်ပါ။'
    },
    {
      title: 'အရောင်းစီမံခန့်ခွဲမှုသည် ယခင်ကထက် ပိုမိုလွယ်ကူလာပါပြီ!',
      detail: 'သင့်စတိုးဆိုင်ကို ဖန်တီးပြီး၊ ထုတ်ကုန်များထည့်ပြီး၊ aSeller POS ဖြင့် အရောင်းစတင်ပါ။'
    }
  ],
  shipping: {
    ...EN.shipping,
    createHint: 'လက်ဖြင့် shipment ဖန်တီးနိုင်သလို provider API ကိုလည်း config ပြီးပါက ခေါ်နိုင်ပါသည်။',
    createMode: 'Create Mode',
    createModeHintManual: 'Internal shipment ကိုဖန်တီးပြီး tracking code ကိုလက်ဖြင့်ထည့်နိုင်ပါသည်။',
    createModeHintProvider: 'Provider API ကိုခေါ်ပြီး shipment ဖန်တီးကာ tracking code ကိုအလိုအလျောက်ရယူပါမည်။',
    providerModeUnavailable: 'ဤ provider သည် API shipment creation အတွက် config မပြည့်သေးသောကြောင့် manual mode ကိုအသုံးပြုပါမည်။',
    providerCodeAutoGenerated: 'Shipment ဖန်တီးမှုအောင်မြင်ပြီးနောက် tracking code ကို provider ကပြန်ပေးပါမည်။',
    providerCreateFailed: 'Provider မှ shipment ဖန်တီးမရသဖြင့် internal shipment ကိုမသိမ်းဆည်းထားပါ။',
    irregularTransitionConfirm: 'ရွေးချယ်ထားသော အခြေအနေသည် ပုံမှန်လုပ်ဆောင်မှုစီးဆင်းမှုတွင် မရှိပါ။ သင် အမှန်တကယ် အပ်ဒိတ်လုပ်လိုပါသလား?',
    invalidProviderConfigJson: 'Credentials သို့မဟုတ် settings JSON မမှန်ပါ',
    providerSettings: 'Provider Settings',
    providerSettingsJson: 'Provider Settings (JSON)',
    providerConfigGuide: 'Suggested fields by provider',
    createModeList: {
      manual: 'Manual Create',
      provider: 'Create via Provider'
    }
  }
};
